<template>
  <master-layout pageTitle="Broadcasts">
    <!-- show listing if non edit mode -->
    <div v-if="!editMode" class="broadcast-listing-content">
      <!-- desktop -->
      <div>
        <div class="custom-tabs">
          <button class="custom-tab" type="button" :class="{ active: activeListingTab === 'broadcasts' }" @click="changeTab('broadcasts')">Broadcasts</button>
          <button class="custom-tab" type="button" :class="{ active: activeListingTab === 'draft_broadcast' }" @click="changeTab('draft_broadcast')">Drafts</button>
        </div>
        <div>    
        <!-- Search bar -->
        <div class="broadcast-search-container">
          <SearchBar
            v-if="activeListingTab === 'broadcasts'"
            v-model="broadcastFilter"
            placeholder="Search broadcast"
            :rightIcon="true"
            @search="debouncedBroadcastSearch()"
            class="broadcast-search-field"
          />
          <SearchBar
            v-else-if="activeListingTab === 'draft_broadcast'"
            v-model="draftBroadcastFilter"
            placeholder="Search draft broadcast"
            :rightIcon="true"
            @search="debouncedDraftBroadcastSearch()"
            class="broadcast-search-field"
          />

          <div class="ion-hide-md-down flexBox">
            <VButton @click="fetchInitialData()" appearance="filled" connotation="cta" aria-label="refresh">
              <template #icon><VIcon name="refresh-line" /></template>
            </VButton>
            <VButton v-if="activeListingTab == 'broadcasts'" class="vvd-btn-primary" connotation="cta" appearance="filled" label="View Analytics" @click="$router.push('/analytics/broadcast')"></VButton>
            <VButton v-if="!editMode" class="vvd-btn-primary" connotation="cta" appearance="filled" :label="activeListingTab === 'draft_broadcast' ? 'Create Draft Broadcast' : 'Create Broadcast'" @click="onClickAddNewBroadcast"></VButton>
          </div>
          <div class="ion-hide-md-up">
            <div class="circle-wrapper">
              <ActionPopOver :style="{'--width': '160px'}">
                <div class="listContainer">
                  <button v-if="activeListingTab == 'broadcasts'" @click="$router.push('/analytics/broadcast')" class="btn-outline"> View Analytics </button>
                  <button @click="onClickAddNewBroadcast" class="btn-outline"> {{ activeListingTab === 'draft_broadcast' ? 'Create Draft Broadcast' : 'Create Broadcast' }} </button>
                  <button @click="fetchInitialData()" class="btn-outline"> Refresh </button>
                </div>
              </ActionPopOver>
            </div>
          </div>
        </div>
        <div v-if="allbroadcasts.length > 0 && activeListingTab === 'broadcasts' " class="info-box gridMargin">
          <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
          <p class="info-text ion-no-margin">'Broadcast outcome' is available 30 minutes post execution</p>
        </div>
        <div v-if="activeListingTab === 'broadcasts'" class="gridMargin">
          <ViewBroadcastList
            :broadcasts="broadcastsToShow"
            :canLoadMore="canLoadMoreBroadcasts"
            :isLoadingMore="broadcastsLoadMore"
            :filter="broadcastFilter || ''"
            @load-more="fetchBroadcasts(true)"
            @view-edit="onListViewEdit"
            @delete="(idx) => (broadcastIndexToDelete = idx)"
            @duplicate="onListDuplicate"
            @download-outcome="downloadCsv_broadcastOutcome"
            @clear-filter="() => { broadcastFilter = undefined; fetchBroadcasts() }"
            @create="onClickAddNewBroadcast"
          />
        </div>
        </div>
        <div v-if="activeListingTab === 'draft_broadcast'" class="gridMargin">
          <ViewBroadcastList
            :broadcasts="draftBroadcastsToShow"
            :isDraft="true"
            :canLoadMore="canLoadMoreDraftBroadcasts"
            :isLoadingMore="draftBroadcastsLoadMore"
            :filter="draftBroadcastFilter || ''"
            @load-more="fetchDraftBroadcasts(true)"
            @view-edit="onListViewEdit"
            @delete="(idx) => (draftbroadcastIndexToDelete = idx)"
            @duplicate="onListDuplicate"
            @download-outcome="downloadCsv_broadcastOutcome"
            @clear-filter="() => { draftBroadcastFilter = undefined; fetchDraftBroadcasts() }"
            @create="onClickAddNewBroadcast"
          />
        </div>
      </div>            
    </div>

    <!-- Message if edit mode and no channels added -->
    <div v-else-if="editMode && !connectedChannels.length" class="no-channel-connected-content">
      <div class="edit-toolbar">
        <div class="toolbar-start">
          <VIcon class="cursorPointer" @click="() => { editMode = false; broadcastIndexToEdit = -1, showMessages = false }" name="arrow-left-line"></VIcon>
          <h2 class="prdt-title ion-no-margin paddingNone">{{ pageTitle }} </h2>
        </div>
      </div>
      <div class="not-channel-connected-text-wrapper">
        <div>
          <img src="@/resources/images/empty_broadcast.svg" class="filterImg" alt="Empty broadcast" />
          <p class="prdt-title">No channel is connected for Broadcast. Please connect any channel to create the Broadcast.</p>
        </div>
      </div>
    </div>

    <!-- show edit mode -->
    <div v-else-if="editMode" class="broadcast-edit-content">
      <div class="edit-toolbar">
        <div class="toolbar-start">
          <VIcon class="cursorPointer" @click="() => {editMode = false; broadcastIndexToEdit = -1; showMessages = false; clearBroadcast()}" name="arrow-left-line"></VIcon>
          <h2 class="prdt-title ion-no-margin paddingNone">{{ pageTitle }} </h2>
        </div>
        <div v-if="editMode && !isViewMode">
           <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" :label="sendNow === 'draft' ? 'Save as draft' : 'Save & Send'" @click="saveBroadcastHandler"></VButton>
        </div>
      </div>
      <div class="ion-hide-md-up">
        <div class="custom-tabs">
          <button class="custom-tab" :class="{ active: activeTab === 'template' }" @click="() => { editMode = true; broadcastIndexToEdit = bIndex; showMessages = true; activeTab = 'template'; }">Template</button>
          <button class="custom-tab" :class="{ active: activeTab === 'preview' }" @click="activeTab = 'preview'">Preview</button>
        </div>
      </div>
      <div class="broadcast-grid gridMargin">
        <div v-if="editBroadcast.sent_status !== 'not_ran_yet' && isViewMode" class="info-box marginBottom">
          <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
          <p class="info-text ion-no-margin">{{ editBroadcast.sent_status == 'running' ? 'Sorry! You cant make changes here as we are currently sending this broadcast to targeted audience' : editBroadcast.sent_status !== 'running' ? 'Sorry! You cant make changes here as we have already executed this broadcast to targeted audience.' : '' }} </p>
        </div>
        <div class="broadcast-row">
          <div v-if="activeTab === 'template'" class="broadcast-col-main"> 
            <div class="accordion-group">
              <div class="accordion-container">
                <div class="accordion-header cust-brdr" @click="accordionGroupChange('select_channel')">
                  <div class="number" :class="{ 'activeAccordion' : selectedAccordion == 'select_channel'}">1</div>
                  <span class="header">Select channel</span>
                  <VIcon name="chevron-down-line" :size="-5" class="accordion-chevron" :class="{ open: selectedAccordion === 'select_channel' }" />
                </div>
                <transition name="accordion-slide">
                <div v-show="selectedAccordion === 'select_channel'" class="accordion-content sectionPadding">
                  <div class="marginBottom">
                    <div class="flex-start paddingBottom flexText">
                      <p class="sub-title ion-no-margin">Broadcast name </p>
                      <HelpTooltip>
                        <ul>
                          <li>Max: 150 characters</li>
                          <li>Please provide the name of the broadcast you would like to use.</li>
                        </ul>
                      </HelpTooltip>
                    </div>
                    <div class="counter-wrapper">
                      <VTextField type="text" v-model="editBroadcast.name" :readonly="isViewMode" :maxlength="150" placeholder="Enter Name" aria-label="name" appearance="ghost" class="vivid-input"></VTextField>
                      <div class="custom-counter">
                        {{ (editBroadcast.name || '').length }}/150
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="sub-title ion-no-margin paddingBottom">Messaging channel </p>
                    <div class="radio-bttn-container create-broadcast-channel-selection-radio-group">
                      <label v-for="thisCategory in channelsToRender" :key="thisCategory.name" class="radio-card" :class="{ selected: selectedBroadCastChannel === thisCategory.value, disabled: isViewMode }" @click="!isViewMode && onSelectBroadCastChannel(thisCategory) && onChangeChannel()">
                        <input type="radio" :value="thisCategory.value" :checked="selectedBroadCastChannel === thisCategory.value" :disabled="isViewMode" class="radio-hidden" />
                        <div class="radioContainer">
                          <img :src="thisCategory.img" :alt="`${thisCategory.name} logo`" width="25" />
                          <span class="title">{{ thisCategory.name }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-if="selectedBroadCastChannel == 'sms' && senderIDs.length > 0" class="marginTop">
                    <div class="flex-start paddingBottom flexText">
                      <p class="sub-title ion-no-margin">Send broadcast using sender ID</p>
                      <HelpTooltip>
                        <p class="ion-no-margin"><b>Case 1: Using File Upload</b></p>
                        <ul>
                          <li>When <b>“Custom”</b> Sender ID is selected, you can upload a file containing unique Sender IDs mapped to each contact.</li>
                          <li>If a valid Sender ID is found in the uploaded file for a contact, that Sender ID will be used.</li>
                          <li>If no valid Sender ID is found in the file, the system will check the CRM custom field. If no valid Sender ID exists there either, it will fall back to the <b>default account-level Sender ID.</b></li>
                          <li>If <b>“Custom”</b> is <b>not</b> selected, the <b>broadcast-level Sender ID</b> will override any Sender IDs in the uploaded file, any in CRM custom fields, as well as the default account-level Sender ID.</li>
                        </ul>
                        <p class="ion-no-margin"><b>Case 2: Using Filters or Segments</b></p>
                        <ul>
                          <li>When <b>“Custom” Sender ID is selected</b>, you can use CRM custom fields mapped to contacts, selected via filters or segments.</li>
                          <li>If a valid Sender ID exists in the mapped CRM custom field for a contact, that Sender ID will be used.</li>
                          <li>If no valid Sender ID is found in the CRM custom field, the system will fall back to the <b>default account-level Sender ID.</b></li>
                          <li>If <b>“Custom”</b> is <b>not</b> selected, the <b>broadcast-level Sender ID</b> will override any Sender IDs stored in CRM custom fields, as well as the default account-level Sender ID.</li>
                        </ul>
                      </HelpTooltip>
                    </div>
                    <VSelect :disabled="isViewMode" v-model="selectSMSSenderID" aria-label="purpose" placeholder="Select senderID" appearance="ghost" class="vivid-select">
                      <VOption value="custom" text="Custom"></VOption>
                      <VOption v-for="(number, index) in senderIDs" :value="number" :key="index" :text="String(number)"></VOption>
                    </VSelect>
                  </div>
                  <div v-if="selectedBroadCastChannel == 'email' && senderEmails.length > 0" class="marginTop">
                    <div class="flex-start paddingBottom flexText">
                      <p class="sub-title ion-no-margin">Send Broadcast using Sender Email Address</p>
                      <HelpTooltip>
                        <p class="ion-no-margin"><b>Case 1: Using File Upload</b></p>
                        <ul>
                          <li>When <b>“Custom”</b> Sender ID is selected, you can upload a file containing unique Sender IDs mapped to each contact.</li>
                          <li>If a valid Sender ID is found in the uploaded file for a contact, that Sender ID will be used.</li>
                          <li>If no valid Sender ID is found in the file, the system will check the CRM custom field. If no valid Sender ID exists there either, it will fall back to the <b>default account-level Sender ID.</b></li>
                          <li>If <b>“Custom”</b> is <b>not</b> selected, the <b>broadcast-level Sender ID</b> will override any Sender IDs in the uploaded file, any in CRM custom fields, as well as the default account-level Sender ID.</li>
                        </ul>
                        <p class="ion-no-margin"><b>Case 2: Using Filters or Segments</b></p>
                        <ul>
                          <li>When <b>“Custom” Sender ID is selected</b>, you can use CRM custom fields mapped to contacts, selected via filters or segments.</li>
                          <li>If a valid Sender ID exists in the mapped CRM custom field for a contact, that Sender ID will be used.</li>
                          <li>If no valid Sender ID is found in the CRM custom field, the system will fall back to the <b>default account-level Sender ID.</b></li>
                          <li>If <b>“Custom”</b> is <b>not</b> selected, the <b>broadcast-level Sender ID</b> will override any Sender IDs stored in CRM custom fields, as well as the default account-level Sender ID.</li>
                        </ul>
                      </HelpTooltip>
                    </div>
                    <VSelect :disabled="isViewMode" v-model="selectEmailSender" aria-label="sender email" placeholder="Select sender email" appearance="ghost" class="vivid-select">
                      <VOption value="custom" text="Custom"></VOption>
                      <VOption v-for="(sender, index) in senderEmails" :key="index" :value="sender.email" :text="sender.displayName ? `${sender.displayName} <${sender.email}>` : sender.email"></VOption>
                    </VSelect>
                  </div>
                </div>
                </transition>
              </div> 
              <div class="accordion-container">
                <div class="accordion-header cust-brdr" @click="accordionGroupChange('create_message')">
                  <div class="number" :class="{ 'activeAccordion' : selectedAccordion == 'create_message'}">2</div>
                  <span class="header">Create message</span>
                  <VIcon name="chevron-down-line" :size="-5" class="accordion-chevron" :class="{ open: selectedAccordion === 'create_message' }" />
                </div>
                <transition name="accordion-slide">
                <div v-show="selectedAccordion === 'create_message'" class="accordion-content sectionPadding">
                  <AbTesting :selectedOption="abTestingOn" :isViewOnlyMode="isViewMode" :selectedTargetingFilters="targetingOption" :selectedRange="distributionRange" @onUpdate="onRangeUpdate" :distributionProbability="editBroadcast?.distribution_probability || ''"></AbTesting>
                  <div>
                    <div v-if="abTestingOn" class="custom-tabs">
                      <button class="custom-tab" :class="{ active: activeTabAbTesting === VERSION_A }" @click="activeTabAbTesting = VERSION_A">Version A</button>
                      <button class="custom-tab" :class="{ active: activeTabAbTesting === VERSION_B }" @click="activeTabAbTesting = VERSION_B">Version B</button>
                    </div>
                    <!-- VERSION_A is default. If ab testing is off then VERSION_A would be visible -->
                    <div :class="{ hideVersion: activeTabAbTesting == VERSION_B}">
                      <WhatsAppCreateMessage v-if="selectedBroadCastChannel == 'whatsapp' && allTemplates && allTemplates.length" :key="'componentKey_A_' + componentKey"
                       :editBroadcast="editBroadcast" :allWhatsappTemplateData="allTemplates" ref="whatsAppCreateMessage_A" versionManager="whatsAppCreateMessage_A" @onUpdatePreview="(value) => { objWhatsAppPreview_A = value }" @alltemplateValues="(value) => getTemplateData(value, 'A')" @templatesLoading="(value) => { isTemplateLoading = value }" @updatedMedia="(formattedObject) => { editBroadcast.wa_message_params.HEADER = [formattedObject]; }" @resetValues="(value) => { editBroadcast.id = value; }" :isViewMode="isViewMode" :isDuplicateBroadcast="isDuplicateBroadcast" @final-url-type="(value) => { finalUrlType = value}" :url_type="editBroadcast?.url_types?.HEADER[0]" @carouselMessageUpdated="(value) => { if(allTemplateData_A.message) allTemplateData_A.message = value; }"></WhatsAppCreateMessage>
                      <JsonBuilderWrapper ref="JsonBuilderWrapper_A" v-if="['googlercs', 'sms'].includes(selectedBroadCastChannel) && showMessages" :editBroadcast="editBroadcast" :uploaded_url_type="editBroadcast?.url_types?.HEADER[0]" :isViewOnlyMode="isViewMode" :isEditMode="isEditMode" :enableURLUpload="shoudlURLUploadOpen"
                        @finalJsonElements="({finalJsonElements}) => adMessageJsonElements_A = finalJsonElements " @carouselData="data => { rcsCarouselData_A = data; }" @final-url-type="(value) => { finalUrlType = value}"></JsonBuilderWrapper>
                      <EmailCreateMessage v-if="selectedBroadCastChannel === 'email' && showMessages" ref="emailCreateMessage_A" :editBroadcast="editBroadcast" :isViewMode="isViewMode" @emailDataUpdate="(data) => { emailData_A = data }" />
                    </div>
                    <div v-if="abTestingOn" :class="{ hideVersion: activeTabAbTesting == VERSION_A}">
                       <WhatsAppCreateMessage v-if="selectedBroadCastChannel == 'whatsapp' && allTemplates && allTemplates.length" :key="'componentKey_B_' + componentKey"
                      :editBroadcast="editBroadcast_version_B" :allWhatsappTemplateData="allTemplates" versionManager="whatsAppCreateMessage_B" ref="whatsAppCreateMessage_B" @onUpdatePreview="(value) => { objWhatsAppPreview_B = value }" @alltemplateValues="(value) => getTemplateData(value, 'B')" @templatesLoading="(value) => { isTemplateLoading_B = value }" @updatedMedia="(formattedObject) => { editBroadcast_version_B.wa_message_params.HEADER = [formattedObject]; }"  @resetValues="(value) => { editBroadcast_version_B.id = value; }"  :isViewMode="isViewMode" :isDuplicateBroadcast="isDuplicateBroadcast" @final-url-type="(value) => { finalUrlType_B = value}" :url_type="editBroadcast_version_B?.url_types_b?.HEADER[0]" @carouselMessageUpdated="(value) => { if(allTemplateData_B.message) allTemplateData_B.message = value; }"></WhatsAppCreateMessage>
                      <JsonBuilderWrapper ref="JsonBuilderWrapper_B" v-if="['googlercs', 'sms'].includes(selectedBroadCastChannel) && showMessages" :editBroadcast="editBroadcast_version_B" :uploaded_url_type="editBroadcast?.url_types_b?.HEADER[0]" :isViewOnlyMode="isViewMode" :isEditMode="isEditMode" :enableURLUpload="shoudlURLUploadOpen"
                      @finalJsonElements="({finalJsonElements}) => adMessageJsonElements_B = finalJsonElements " @carouselData="data => { rcsCarouselData_B = data; }" @final-url-type="(value) => { finalUrlType_B = value}"></JsonBuilderWrapper>
                      <EmailCreateMessage v-if="selectedBroadCastChannel === 'email' && showMessages" ref="emailCreateMessage_B" :editBroadcast="editBroadcast_version_B" :isViewMode="isViewMode" @emailDataUpdate="(data) => { emailData_B = data }" />
                    </div>
                  </div>
                </div>
                </transition>
              </div>
              <!-- FallBack Message Container-->
              <div v-if="isFallBackMessageEnabled" class="accordion-container" :class="{ 'accordion-open': selectedAccordion === 'fallback_message' }">
                <div class="accordion-header cust-brdr" @click="accordionGroupChange('fallback_message')">
                  <div class="number" :class="{ 'activeAccordion' : selectedAccordion == 'fallback_message'}">3</div>
                  <span class="header">Fallback message (SMS only)</span>
                  <VIcon name="chevron-down-line" :size="-5" class="accordion-chevron" :class="{ open: selectedAccordion === 'fallback_message' }" />
                </div>
                <transition name="accordion-slide">
                <div v-if="selectedAccordion === 'fallback_message'" class="accordion-content sectionPadding">
                  <div v-if="senderIDs.length > 0" class="marginBottom">
                    <div class="flex-start paddingBottom flexText">
                      <p class="sub-title ion-no-margin">Send broadcast using sender ID</p>
                      <HelpTooltip>
                        <p class="ion-no-margin"><b>Case 1: Using File Upload</b></p>
                        <ul>
                          <li>When <b>“Custom”</b> Sender ID is selected, you can upload a file containing unique Sender IDs mapped to each contact.</li>
                          <li>If a valid Sender ID is found in the uploaded file for a contact, that Sender ID will be used.</li>
                          <li>If no valid Sender ID is found in the file, the system will check the CRM custom field. If no valid Sender ID exists there either, it will fall back to the <b>default account-level Sender ID.</b></li>
                          <li>If <b>“Custom”</b> is <b>not</b> selected, the <b>broadcast-level Sender ID</b> will override any Sender IDs in the uploaded file, any in CRM custom fields, as well as the default account-level Sender ID.</li>
                        </ul>
                        <p class="ion-no-margin"><b>Case 2: Using Filters or Segments</b></p>
                        <ul>
                          <li>When <b>“Custom” Sender ID is selected</b>, you can use CRM custom fields mapped to contacts, selected via filters or segments.</li>
                          <li>If a valid Sender ID exists in the mapped CRM custom field for a contact, that Sender ID will be used.</li>
                          <li>If no valid Sender ID is found in the CRM custom field, the system will fall back to the <b>default account-level Sender ID.</b></li>
                          <li>If <b>“Custom”</b> is <b>not</b> selected, the <b>broadcast-level Sender ID</b> will override any Sender IDs stored in CRM custom fields, as well as the default account-level Sender ID.</li>
                        </ul>
                      </HelpTooltip>
                    </div>
                    <VSelect :disabled="isViewMode" v-model="selectSMSSenderID" aria-label="purpose" placeholder="Select senderID" appearance="ghost" class="vivid-select">
                      <VOption value="custom" text="Custom"></VOption>
                      <VOption v-for="(number, index) in senderIDs" :value="number" :key="index" :text="String(number)"></VOption>
                    </VSelect>
                  </div>
                  <div class="info-box marginBottom">
                    <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                    <div>
                      <p class="info-text ion-no-margin">1. Avoid using the entire character count limit when your message contains message variables.</p>
                      <p class="info-text ion-no-margin">2. Transcoding is not available for a message with custom variables </p>
                    </div>
                  </div> 
                  <div class="fallBackMessages marginBottom">
                    <div class="fallBackMessages">
                      <p class="title ion-no-margin">Enable fallback message</p>
                      <HelpTooltip :iconStyle="{'padding-top': '3px'}">Configure a message for the SMS failover option to ensure delivery to the customer in cases where the primary channel delivery fails</HelpTooltip>
                    </div>
                    <div class="toggle-wrapper">
                      <VSwitch v-model="enableFallBackMessage" :disabled="isViewMode"></VSwitch>
                    </div>
                  </div>
                  <div class="fallBackContainer">
                    <RichTextBoxV2
                      ref="FallBackRichTextBox"
                      :value="parseBodyText(fallbackMessagePayload)"
                      :showSmiley="true"
                      :showCustomFiledInsertion="true"
                      :maxLength="1000"
                      :readonly="isViewMode || !enableFallBackMessage"
                      :showBotVariable="false"
                      @input="(prop) => fallbackMessagePayload = prop"
                    />
                    <div class="transcodeContainer">
                      <div class="flex-start flexText alignCenter">
                        <VButton icon="toggle-line" label="Transcode" appearance="outlined" connotation="cta" @click="getSmsTranscodedMessage(fallbackMessagePayload)" :disabled="fallbackMessagePayload == '' || !enableFallBackMessage || isTranscodeEnabledForSms(fallbackMessagePayload) || isViewMode"></VButton>
                        <HelpTooltip>Use transcoding when your SMS contains characters (such as emojis, special symbols, or non-Latin languages) that may not be supported by all devices or networks. Transcoding helps ensure message delivery and can reduce costs by converting the message to a compatible, lower-cost format like GSM-7.</HelpTooltip>
											</div>
                    </div>
                  </div>
                </div>
                </transition>
              </div>
              <div class="accordion-container" :class="{ 'accordion-open': selectedAccordion === 'settings' }">
                <div class="accordion-header cust-brdr" @click="accordionGroupChange('settings')">
                  <div class="number" :class="{ 'activeAccordion' : selectedAccordion == 'settings'}">{{ isFallBackMessageEnabled ? '4' : '3' }}</div>
                  <span class="header">Settings</span>
                  <VIcon name="chevron-down-line" :size="-5" class="accordion-chevron" :class="{ open: selectedAccordion === 'settings' }" />
                </div>
                <transition name="accordion-slide">
                <div v-show="selectedAccordion === 'settings'" class="accordion-content sectionPadding">
                  <!-- Common settings options -->
                  <div class="marginBottom">
                    <p class="sub-title ion-no-margin paddingBottom">How would you like to proceed with the targeting?</p>
                    <VSelect appearance="ghost" aria-label="targeting" placeholder="Select targeting Options" v-model="targetingOption" @change="resetUploadedFileObject" :disabled="isViewMode" class="vivid-select" fixed-dropdown>
                      <VOption value="SELECT_FILTERS" text="By selecting filters from below"></VOption>
                      <VOption v-if="!abTestingOn && ['whatsapp', 'googlercs', 'sms', 'email'].includes(editBroadcast.channel)" :value="UPLOAD_FILE" text="By uploading a file with customers"></VOption>
                      <VOption value="SELECT_SEGMENT" text="By selecting segments"></VOption>
                    </VSelect>
                  </div>
                  <!-- Data Privacy info-box -->
                  <div class="marginBottom">
                    <div class="warning-info-box">
                      <VIcon name="error-line" class="warningIcon" :size="-4"></VIcon>
                      <p class="info-text ion-no-margin">Please ensure all target customers have opted in to receive communications before sending a broadcast, in order to comply with data privacy regulations and maintain trust.</p>
                    </div> 
                  </div>
                  <div v-if="targetingOption == UPLOAD_FILE" class="segment-filter-section">
                    <div v-if="uploadedFileObject.filePath !== ''" class="selectedCSV width100P marginBottom">
                      <div class="flex-between">
                        <img src="@/resources/images/dummy-uploaded_file.svg" class="fileImg" alt="Uploaded file" />
                        <p class="info-text ion-no-margin">{{ uploadedFileObject.fileName }}</p>
                      </div>
                      <VIcon v-if="!isViewMode" name="delete-line" class="cursorPointer trashIcon defaultIconSize" @click="deleteUploadedFilePath"></VIcon>
                    </div>
                    <input type="file" style="display: none;" id="headerDocument" ref="headerDocument" @input="onSelectUploadFile" accept=".csv" />
                    
                    <div v-if="uploadedFileObject.filePath == ''" class="marginBottom">
                      <p class="sub-title ion-no-margin paddingBottom">File</p>
                      <button @click="() => isOpenImportModal = true" :disabled="isViewMode" class="btn-outline">
                        <VIcon name="clear-file-line" class="icon"></VIcon>
                        <span class="paddingLeft">Upload File</span>
                      </button>
                    </div>
                    <UploadCSVComponent v-if="isOpenImportModal" ref="UploadCSVComponent" type="broadcast" name="Upload a file with customers" :isOpenImportModal="isOpenImportModal" @update:isOpenImportModal="(val) => isOpenImportModal = val" @uploadedFilePath="handleFileUpload" :selectedChannel="selectedBroadCastChannel" :instructions="instructions" :showInstructions="true" acceptTypes=".csv, .xls, .xlsx, .tsv" :showDuplicateColumn="false" />
                  </div>
                  <div v-if="targetingOption == 'SELECT_FILTERS' && showCustomerSegments">
                    <div class="marginBottom segments-wrapper">
                      <CustomerSegments v-if="reloadCustomerSegments" id="CustomerSegments" ref="CustomerSegments" :editBroadcast="editBroadcast" :selectedSocialPageId="selectSocialPageId" @clickedOnAddCondition="onClickAddConditionButton" :noDefaultConditions="false" :isViewOnlyMode="isViewMode"></CustomerSegments>
                    </div>
                  </div>

                  <div v-if="targetingOption == 'SELECT_SEGMENT' && allSegments.length > 0" class="select-segment-wrapper">
                    <div class="sectionPadding">
                      <p class="sub-title ion-no-margin custPadding">Select segment</p>
                      <VSearchableSelect appearance="ghost" aria-label="segment" :disabled="isViewMode" :modelValue="selectedSegment?.id ? String(selectedSegment.id) : ''" @update:modelValue="(val) => { selectedSegment = filteredSegments.find(s => String(s.id) === val) }" placeholder="Select segment" class="vivid-select" fixed-dropdown>
                        <VOption v-for="segment in filteredSegments" :value="String(segment.id)" :key="segment.id" :text="segment.name" :label="segment.name"></VOption>
                      </VSearchableSelect>
                    </div>
                  </div>

                  <div v-if="targetingOption == 'SELECT_SEGMENT' && allSegments.length === 0 && segmentsFetched" class="select-segment-wrapper">
                    <div class="sectionPadding">
                      <p class="sub-title ion-no-margin">No segments available. <router-link to="/customers/segments" class="link-text">Create a segment</router-link> first to use this option.</p>
                    </div>
                  </div>

                  <SegmentsTargetingCount ref="SegmentsTargetingCount" :isURLUpload="targetingOption === UPLOAD_FILE" :isViewOnlyMode="isViewMode" :targeting_count="getTargetingConditionsCount" :sendTag="sendTag" @callFetchTargetedCustomerCount="callFetchTargetedCustomerCount"></SegmentsTargetingCount>
                  <!-- End Common settings options -->            
                </div>
                </transition>
              </div>
              <div class="accordion-container" :class="{ 'accordion-open': selectedAccordion === 'scheduling' }">
                <div class="accordion-header cust-brdr" @click="accordionGroupChange('scheduling')">
                  <div class="number" :class="{ 'activeAccordion' : selectedAccordion == 'scheduling'}">{{ isFallBackMessageEnabled ? '5' : '4' }}</div>
                  <span class="header">Scheduling</span>
                  <VIcon name="chevron-down-line" :size="-5" class="accordion-chevron" :class="{ open: selectedAccordion === 'scheduling' }" />
                </div>
                <transition name="accordion-slide">
                <div v-if="selectedAccordion === 'scheduling'" class="accordion-content sectionPadding">
                  <div>
                    <p class="sub-title ion-no-margin paddingBottom">When would you like to send this broadcast?</p>
                    <div class="schedule-radio-group">
                      <label class="schedule-radio-card" :class="{ selected: sendNow === 'now', disabled: isViewMode }" @click="!isViewMode && (sendNow = 'now')">
                        <input type="radio" value="now" v-model="sendNow" :disabled="isViewMode" class="radio-input" />
                        <div class="radio-label-content">
                          <div class="title paddingBottom">Send Now</div>
                          <div class="sub-title">This broadcast will be sent as soon as you hit the "Save & Send" button!</div>
                        </div>
                      </label>
                      <label class="schedule-radio-card" :class="{ selected: sendNow === 'later', disabled: isViewMode }" @click="!isViewMode && (sendNow = 'later')">
                        <input type="radio" value="later" v-model="sendNow" :disabled="isViewMode" class="radio-input" />
                        <div class="radio-label-content">
                          <div class="title paddingBottom">Send Later</div>
                          <div class="sub-title">This broadcast will be sent on the date & time selected below taking into account the timezone selected as well.</div>
                        </div>
                      </label>
                      <label class="schedule-radio-card" :class="{ selected: sendNow === 'draft', disabled: isViewMode }" @click="!isViewMode && (sendNow = 'draft')">
                        <input type="radio" value="draft" v-model="sendNow" :disabled="isViewMode" class="radio-input" />
                        <div class="radio-label-content">
                          <div class="title paddingBottom">Save as Draft</div>
                          <div class="sub-title">This broadcast will be saved as a draft. You can come back to edit it and schedule it to be sent at any time.</div>
                        </div>
                      </label>
                    </div>

                    <div :class="{ hideSendLaterSection: sendNow !== 'later' }">
                      <div class="marginBottom">
                        <p class="sub-title ion-no-margin marginBottom">Select Timezone</p>
                        <timezone-options v-model="editBroadcast.timezone" class="slctContainer" />
                      </div>
                      <div v-if="editBroadcast.timezone" class="marginBottom">
                        <p class="sub-title ion-no-margin paddingBottom">Select Date &amp; Time</p>
                        <DateTime id="edit-broadcast-send-datetime" v-model="editBroadcast.send_date_time" :minValidation="{ enabled: true, value: 5, type: 'minutes' }" :timezone="editBroadcast.timezone"></DateTime>
                      </div>
                    </div>
                  </div>
                </div>
                </transition>
              </div>
            </div>
          </div>

          <!-- Preview Section -->
            <div v-if="selectedAdMessageJSON.length || selectedBroadCastChannel == 'whatsapp' || selectedBroadCastChannel == 'googlercs' || selectedBroadCastChannel == 'email'" class="broadcast-col-preview model-sections previewContainer">
              <div :class="activeTab === 'preview' ? 'prevMobile' : 'prevDesktop'">
                <div class="previewHeader">
                  <span>Preview</span>
                </div>
                <div class="sectionPadding">
                  <!-- VERSION A -->
                  <div :class="{ hideVersion: activeTabAbTesting == VERSION_B }">
                    <WhatsAppPreview v-if="selectedBroadCastChannel == 'whatsapp'" origin="broadcast" :selectedLanguage="allTemplateData_A.language" :body="objWhatsAppPreview_A" :templateLoading="isTemplateLoading" :templateType="template_subtype_A" :carouselMessage="allTemplateData_A.message" :lto_offerTitleText="allTemplateData?.message?.limited_time_offer?.text" :expiration_date_time="allTemplateData?.messageinfo?.replace_limited_time_offer_key?.expiration_time" :fallBackMessage="fallbackMessagePayload" :checkFallBackMessageEnabled="enableFallBackMessage" :isViewOnlyMode="isViewMode" :isDuplicateBroadcast="isDuplicateBroadcast" :finalUrlType="finalUrlType || editBroadcast?.url_types?.HEADER?.[0] || 'static'"/>
                    <JsonBuilderPreview v-else-if="['googlercs', 'sms'].includes(selectedBroadCastChannel)" :adMessageJsonElements="selectedAdMessageJSON" :selectedChannel="selectedBroadCastChannel" :carouselMessage="rcsCarouselData_A" :fallBackMessage="fallbackMessagePayload" :checkFallBackMessageEnabled="enableFallBackMessage" :isViewOnlyMode="isViewMode" :finalUrlType="finalUrlType || editBroadcast?.url_types?.HEADER?.[0] || 'static'"></JsonBuilderPreview>
                    <!-- Email Preview -->
                    <EmailPreview v-else-if="selectedBroadCastChannel === 'email'" :emailData="emailData_A" />
                  </div>
                  <!-- VERSION B -->
                  <div v-if="abTestingOn" :class="{ hideVersion: activeTabAbTesting == VERSION_A }">
                    <WhatsAppPreview v-if="selectedBroadCastChannel == 'whatsapp'" origin="broadcast" :selectedLanguage="allTemplateData_B.language" :body="objWhatsAppPreview_B" :templateLoading="isTemplateLoading_B" :templateType="template_subtype_B" :carouselMessage="allTemplateData_B.message" :lto_offerTitleText="allTemplateData?.message?.limited_time_offer?.text" :expiration_date_time="allTemplateData?.messageinfo?.replace_limited_time_offer_key?.expiration_time" :fallBackMessage="fallbackMessagePayload" :checkFallBackMessageEnabled="enableFallBackMessage" :isViewOnlyMode="isViewMode" :isDuplicateBroadcast="isDuplicateBroadcast" :finalUrlType="finalUrlType_B || editBroadcast?.url_types_b?.HEADER?.[0] || 'static'"/>
                    <JsonBuilderPreview v-else-if="['googlercs', 'sms'].includes(selectedBroadCastChannel)" :adMessageJsonElements="selectedAdMessageJSON" :selectedChannel="selectedBroadCastChannel" :carouselMessage="rcsCarouselData_B" :fallBackMessage="fallbackMessagePayload" :checkFallBackMessageEnabled="enableFallBackMessage" :isViewOnlyMode="isViewMode" :finalUrlType="finalUrlType_B || editBroadcast?.url_types_b?.HEADER?.[0] || 'static'"></JsonBuilderPreview>
                    <!-- Email Preview -->
                    <EmailPreview v-else-if="selectedBroadCastChannel === 'email'" :emailData="emailData_B" />
                  </div>
                </div>
              </div>
                        </div>
        </div>
      </div>
    </div>
    <!-- targeting conditions modal -->
    <VDialog :open="showSegmentActions" @close="showSegmentActions = false" headline="Select conditions" class="import-modal-wrapper" modal     :style="{ '--dialog-min-inline-size': '550px', '--dialog-max-inline-size': '550px' }">
      <template #body>
        <CustomerSegmentsActions @close="showSegmentActions = false" @actionClick="onActionClick" type="broadcast"></CustomerSegmentsActions>
      </template>
      <template #action-items>
        <VButton connotation="cta" appearance="filled" label="close" @click="showSegmentActions = false"></VButton>
      </template>
    </VDialog>
    <VDialog :open="broadcastIndexToDelete > -1" @close="broadcastIndexToDelete = -1" headline="Are you sure?" modal>
      <template #body>
        <p>You want to delete selected broadcast?</p>
      </template>
      <template #action-items>
        <button class="btn-secondary" @click="broadcastIndexToDelete = -1">Cancel</button>
        <button class="btn-primary" @click="deleteBroadcast()">Yes</button>
      </template>
    </VDialog>
    <VDialog :open="draftbroadcastIndexToDelete > -1" @close="draftbroadcastIndexToDelete = -1" headline="Are you sure?" modal>
      <template #body>
        <p>You want to delete selected draft broadcast?</p>
      </template>
      <template #action-items>
        <button class="btn-secondary" @click="draftbroadcastIndexToDelete = -1">Cancel</button>
        <button class="btn-primary" @click="deleteDraftBroadcast()">Yes</button>
      </template>
    </VDialog>
    <exports-modal-v2 v-if="csvExportWithDateRangeModal" :type="csvExportWithDateRangeModal_type" :isOpen="csvExportWithDateRangeModal" :title="csvExportWithDateRangeModal_title" :downloadID="downloadID" @close="() => csvExportWithDateRangeModal = false"></exports-modal-v2>
  </master-layout>

</template>

<script>
import { useSocialConnections } from '@/composables/useSocialConnections';
import { useUIStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';
import { environment } from '@/shared/env.js';
// Ionic imports removed - migrated to Vivid

const close = 'close-line';
import JsonBuilderWrapper from "./json-builder-wrapper.vue";
import JsonBuilderPreview from "./json-builder-preview.vue";
import EmailCreateMessage from "./email-create-message.vue";
import EmailPreview from "./email-preview.vue";
import CustomerSegments from "@/components/customer-segments/customer-segments-v2.vue";
import SegmentsTargetingCount from "@/components/customer-segments/SegmentsTargetingCount.vue";
import CustomerSegmentsActions from "@/components/customer-segments/customer-segment-actions.vue";
import WhatsAppCreateMessage from "./whats-app-create-message.vue";
import WhatsAppPreview from "./whats-app-preview.vue";
import moment from 'moment-timezone';
import ActionPopOver from "@/components/ActionPopOver.vue";
import timezoneOptions from '@/components/timezoneOptions.vue';
import DateTime from "@/components/DateTime.vue";
import exportsModalV2 from '@/components/exportModalV2.vue';
import AbTesting from './a-b-testing.vue'
import { useCsvExportModal } from '@/composables/useCsvExportModal';
import { parseTargetingConditions } from '@/helpers/segments.helpers';
import HelpTooltip from "@/components/HelpTooltip.vue";
import messageTags from '@/resources/data/message-tags.json';
import apiInterceptor from '@/shared/apiInterceptor';
import UploadCSVComponent from '@/components/upload-csv-component.vue';
import { whatsappTemplatesQueryOptions } from '@/composables/useWhatsappTemplates';
import { segmentsQueryOptions } from '@/composables/useSegments';
import { queryClient } from '@/shared/queryClient';
import whatsappIcon from '@/resources/images/whatsapp_icon.svg';
import smsLogo from '@/resources/images/sms_logo.svg';
import googleRcsIcon from '@/resources/images/Google_RCS_icon.svg';
import emailIcon from '@/resources/images/email_icon.svg';
import RichTextBoxV2 from '@/components/rich-text-box-v2.vue';
import ViewBroadcastList from './ViewBroadcastList.vue';
import SearchBar from '@/components/SearchBar.vue';
import { isTranscodeEnabledForSms } from '@/helpers/sms.helper.js';
import { validateRcsUrl, findInvalidRcsButtonUrl } from '@/helpers/rcs-url.helpers.js';
import { parseSenderEmails, resolveDefaultSenderEmail, formatEmailSenderId, buildEmailMessage, hydrateEmailDataFromBroadcast as mapEmailDataFromBroadcast, hydrateEmailDataFromBroadcastVersionB as mapEmailDataFromBroadcastVersionB } from '@/helpers/email.helpers';


function jsonSizeInKB(jsonObject) {
  const jsonString = JSON.stringify(jsonObject);
  const bytes = new TextEncoder().encode(jsonString).length;
  const kb = bytes / 1024;
  return kb;
}

const VERSION_A = 'VERSION_A', VERSION_B = 'VERSION_B', UPLOAD_FILE = 'UPLOAD_FILE';

const availableCategories = [
  {
    name: "WhatsApp",
    value: "whatsapp",
    img: whatsappIcon,
    selected: false,
    supported_templates: "all",
    active: true,
    id: "whatsapp"
  },
  {
    name: "Google RCS",
    value: "googlercs",
    img: googleRcsIcon,
    selected: false,
    supported_templates: "all",
    active: true,
    id: "googlercs",
  },
  {
    name: "SMS",
    value: "sms",
    img: smsLogo,
    selected: false,
    supported_templates: "buttonreply",
    active: true,
    id: "sms",
  },
  {
    name: "Email",
    value: "email",
    img: emailIcon,
    selected: false,
    supported_templates: "all",
    active: true,
    id: "email",
  },
];

const editBroadcast = {
  answers: [],
  category: null,
  channel: availableCategories[0].value,
  commentmessages: "",
  custom_field: null,
  custom_messages: [],
  file_path: undefined,
  id: undefined,
  last_sent: null,
  message: undefined,
  name: "",
  pageid: null,
  runaction: "",
  send_date_time: null,
  sendtag: undefined,
  sent_status: '',
  subcategory: null,
  targeting_conditions: [],
  targeting_count: 0,
  targeting_created: undefined,
  timezone: null,
  version: "v4.0",
  wa_language: "en",
  wa_message_params: { BODY: [], HEADER: [] },
  wa_message_paramslisted: { BODY: [], HEADER: [] },
  wa_templategid: undefined,
  failover_answers: [],
  canLoadMore: true,
  url_types: {
    HEADER: []
  }
};

export default {
  mixins: [],
  setup() {
    const { getWhatsApp, getGooglercs, getSMS, getEmail, connectedChannels } = useSocialConnections();
    return { getWhatsApp, getGooglercs, getSMS, getEmail, connectedChannels, ...useCsvExportModal() };
  },
  components: {
    SearchBar,
    JsonBuilderWrapper,
    JsonBuilderPreview,
    EmailCreateMessage,
    EmailPreview,
    CustomerSegments,
    WhatsAppCreateMessage,
    WhatsAppPreview,
    ActionPopOver,
    SegmentsTargetingCount,
    timezoneOptions,
    CustomerSegmentsActions,
    DateTime,
    exportsModalV2,
    AbTesting,
    HelpTooltip,
    UploadCSVComponent,
    RichTextBoxV2,
    ViewBroadcastList,
  },
  data() {
    return {
      close,
      allbroadcasts: [],
      allDraftBroadcasts: [],
      broadcastsLoadMore: false,
      draftBroadcastsLoadMore: false,
      broadcastsLoaded: false,
      broadcastIndexToDelete: -1,
      draftbroadcastIndexToDelete: -1,
      broadcastIndexToEdit: -1,
      broadcastFilter: undefined,
      draftBroadcastFilter: undefined,
      editMode: false,
      // Pagination cursors are kept per list — the two tabs page independently,
      // so a single shared cursor would leak between them.
      broadcastsNextCursor: undefined,
      draftBroadcastsNextCursor: undefined,
      sendMode: "csv",
      activeTab: 'template',
      filterConditions: "and", //or,
      addCondtionMode: false,
      sendNow: 'now',
      availableCategories,
      selectedBroadCastChannel: availableCategories[0].value,
      editBroadcast: {...editBroadcast },
      adMessageJsonElements_A: [],
      adMessageJsonElements_B: [],
      rcsCarouselData_A: [],
      rcsCarouselData_B: [],
      emailData_A: null,
      emailData_B: null,
      targetingOption: 'SELECT_FILTERS',
      allSegments: [],
      selectedSegment: '',
      objWhatsAppPreview_A: {},
      objWhatsAppPreview_B: {},
      isTemplateLoading: false,
      isTemplateLoading_B: false,
      template_subtype_A: '',
      template_subtype_B: '',
      broadCastOutcomeId: undefined,
      selectedChannel: '',
      showSegmentActions: false,
      showCustomerSegments: true,
      segmentActionPosition: {
        top: 0,
        left: 0,
        width: 0,
        position: 'fixed'
      },
      activeTabAbTesting: VERSION_A,
      abTestingOn: false,
      VERSION_A,
      VERSION_B,
      UPLOAD_FILE,
      notificationsLoading: false,
      selectedAccordion: 'select_channel',
      enableFallBackMessage: false,
      fallbackMessagePayload: '',
      template_subtype: '',
      allTemplateData: {},
      allTemplateData_A: {},
      allTemplateData_B: {},
      editorOption: {
        placeholder: 'Fallback Message',
      },
      simpleMessageTags: [],
      intervalId: null,
      isOpenImportModal: false,
      uploadedFileObject: {
        fileName: '',
        filePath: ''
      },
      showMessages: false,
      broadcastCache: [],
      isDuplicateBroadcast: false,
      finalFallBackMessageArray: [{
        message: [],
        template_type: "normalchat",
      }],
      distributionRange: 10,
      reloadCustomerSegments: false,
      componentKey: 0,
      allTemplates: [],
      finalUrlType: 'static',
      finalUrlType_B: 'static',
      activeListingTab: 'broadcasts',
      iseditDraftbroadcast: false,
      selectSMSSenderID: '',
      selectEmailSender: '',
      fileUploadCount: 0,
      isNewFileUploaded: false,
      canLoadMoreBroadcasts: false,
      canLoadMoreDraftBroadcasts: false,
      draftBroadcastsFetched: false,
      // Shop the broadcast list was last loaded for. Used to re-fetch when the
      // user switches shop, since Ionic keeps this page cached (no re-mount).
      loadedForShop: undefined,
      segmentsFetched: false
    };
  },
  computed: {
    // getWhatsApp, getGooglercs, getSMS, connectedChannels provided by setup() via useSocialConnections composable
    smsSocialData() { return this.getSMS; },
    emailSocialData() { return this.getEmail; },
    senderEmails() {
      // The email connection API returns sender_ids as an array of strings in the
      // "email:DisplayName" format.
      return parseSenderEmails(this.emailSocialData);
    },
    getTargetingConditionsCount() {
      if (this.isViewMode) {
        return this.editBroadcast?.targeting_count;
      }
      return this.isNewFileUploaded ? this.fileUploadCount : this.editBroadcast?.targeting_count;
    },
    pageTitle() {
      return this.isViewMode ? 'View Broadcast' : this.editBroadcast?.id && !this.isDuplicateBroadcast ? 'Update Broadcast' : 'Create Broadcast';
    },
    isViewMode() {
      return (['running', 'done', "Loading"].includes(this.editBroadcast?.sent_status) && !this.isDuplicateBroadcast);
    },
    isEditMode() {
      return this.editBroadcast?.id ? true : false;
    },
    shoudlURLUploadOpen() {
      return this.editBroadcast.channel == 'googlercs'
    },
    selectSocialPageId() {
      let pageId;
      switch (this.editBroadcast.channel) {
        case 'whatsapp':
          pageId = this.getWhatsApp?.id;
        break;
        case 'sms':
          pageId = this.getSMS?.id;
          break;
        case 'googlercs':
          pageId = this.getGooglercs?.id;
        break
        case 'email':
          pageId = this.getEmail?.id;
        break
      }
      return pageId;
    },
    broadcastsToShow() {
      let broadcasts = [];
      this.allbroadcasts.forEach((broadcast) => {
        let extendObj = {};
        const { send_date_time, last_sent, created, timezone, sent_status, targeting_count, channel } = broadcast;
        extendObj.executionLabel = sent_status === 'done' ? 'Executed on' : 'Scheduled for';
        extendObj.executionTz = timezone || useAuthStore().cleanUserData?.timezone || moment.tz.guess();
        extendObj.outcomeLoading = this.broadCastOutcomeId == broadcast.id;

        // set delete button enabled or not
        extendObj.isEnabledDeleteButton = ['done', 'not_ran_yet'].includes(broadcast.sent_status);
        extendObj.isEnabledEditButton = ['done', 'not_ran_yet'].includes(broadcast.sent_status)

        // visibility of download broadcast csv
        extendObj.showDownloadCsv = ![null, undefined, '', 'null', 'undefined'].includes(broadcast.file_path?.trim()) && broadcast.targeting_count && broadcast.targeting_count != null && broadcast.targeting_count <= 100000;


        // format created date
        const createdUtcFormat = moment.utc(created).toDate();
        if (useAuthStore().cleanUserData?.timezone) {
          extendObj.createdOnFormatted = moment(createdUtcFormat).tz(useAuthStore().cleanUserData?.timezone).format('DD-MM-YYYY HH:mm');
        } else {
          extendObj.createdOnFormatted = moment(createdUtcFormat).local().format('DD-MM-YYYY HH:mm');
        }
        // ***** end format created date *****


        // format execution date
        extendObj.executionDate = send_date_time || last_sent;
        if (extendObj.executionDate) {
          const executionUtcFormat = moment(extendObj.executionDate).toDate();
          extendObj.executionDate = moment(executionUtcFormat).format('DD-MM-YYYY HH:mm');
        } else {
          extendObj.executionDate = extendObj.createdOnFormatted
        }
        // ***** end format created date *****

        // broadcast outcome button visibility
        const isValidTargetingCount = targeting_count && targeting_count != null;
        const statusDone = sent_status == "done";
        const isAllowedChannels = ["whatsapp", "googlercs", "sms"].includes(channel);
        const isExecuted_30min_later = this.broadcastExecuted_30mins_later(last_sent, created, timezone) == true;
        const now = moment().tz(extendObj.executionTz);
        const createdTime = moment(createdUtcFormat).tz(extendObj.executionTz);
        const is_30min_passed_from_created = now.diff(createdTime, 'minutes') > 30 && now > createdTime;
        extendObj.isVisibleBroadcastOutcomeButton = is_30min_passed_from_created && isValidTargetingCount && statusDone && isAllowedChannels && isExecuted_30min_later;
        // ***** end broadcast outcome visibility

        const filterChannel = this.availableCategories.filter(elm => elm.value == channel);
        extendObj.img = filterChannel && filterChannel[0]?.img;
        
        broadcasts.push({ ...broadcast, ...extendObj });
      })
      return broadcasts;
    },
    draftBroadcastsToShow() {
      let draftBroadcasts = [];
      this.allDraftBroadcasts.forEach((broadcast) => {
        let extendObj = {};
        const { created, channel } = broadcast;
        // format created date
        const createdUtcFormat = moment.utc(created).toDate();
        if (useAuthStore().cleanUserData?.timezone) {
          extendObj.createdOnFormatted = moment(createdUtcFormat).tz(useAuthStore().cleanUserData?.timezone).format('DD-MM-YYYY HH:mm');
        } else {
          extendObj.createdOnFormatted = moment(createdUtcFormat).local().format('DD-MM-YYYY HH:mm');
        }
        // ***** end format created date *****

        const filterChannel = this.availableCategories.filter(elm => elm.value == channel);
        extendObj.img = filterChannel && filterChannel[0]?.img;
        draftBroadcasts.push({ ...broadcast, ...extendObj });
      })
      return draftBroadcasts;
    },
    allEditBroadcastFilterQueries() {
      return this.editBroadcast.targeting_conditions.map((e) => decodeURIComponent(e.query));
    },
    channelsToRender() {
      let channelsToRender = [];
      this.availableCategories.map((channel) => {
        if (channel.active && this.connectedChannels.includes(channel.id)) {
          channelsToRender.push({...channel});
        }
      });
      return channelsToRender;
    },
    segmentActionStyle() {
      return {
        top: `${this.segmentActionPosition.top}px`,
        left: `${this.segmentActionPosition.left}px`,
        width: `${this.segmentActionPosition.width}px`,
        position: this.segmentActionPosition.position,
        'z-index': 999
      }
    },
    selectedAdMessageJSON() {
      if(this.activeTabAbTesting == VERSION_A) {
        return this.adMessageJsonElements_A;
      } else {
        return this.adMessageJsonElements_B;
      }
    },
    selectedObjWhatsAppPreview() {
      if(this.activeTabAbTesting == VERSION_A) {
        return this.objWhatsAppPreview_A;
      } else {
        return this.objWhatsAppPreview_B;
      }
    },
    editBroadcast_version_B() {
      let editBroadcast = JSON.parse(JSON.stringify(this.editBroadcast));
      editBroadcast.messages = editBroadcast.messagelisted || [];
      editBroadcast.message_params = editBroadcast.message_paramslisted || "";
      editBroadcast.custom_messages = editBroadcast.custom_messagelisted || [];

      editBroadcast.answers = editBroadcast.answerlisted;
      editBroadcast.wa_templategid = editBroadcast.wa_templategids;
      editBroadcast.wa_templateid = editBroadcast.wa_templateids;
      editBroadcast.wa_message_params = editBroadcast.wa_message_paramslisted;
      // Version B email content is stored in answerlisted/messagelisted (parallel to
      // Version A's answers). Rehydrate it the same way RCS Version B rehydrates.
      if (this.editBroadcast?.channel === 'email') {
        editBroadcast.email_data = mapEmailDataFromBroadcastVersionB(this.editBroadcast);
      }
      return editBroadcast;
    },
    sendTag() {
      switch(this.editBroadcast?.channel) {
        default: return undefined
      }
    },
    filteredSegments() {
      return this.allSegments.filter(segment => 
        this.getThisSegmentChannel(segment) === this.editBroadcast.channel
      );
    },
    isFallBackMessageEnabled() {
      return ['whatsapp', 'googlercs'].includes(this.editBroadcast.channel) && !!this.getSMS
    },
    // getDownloadUrl() {
    //   return `${environment('VUE_APP_ROOT')}api/download-broadcast-preset-file?id=${this.editBroadcast.id}`;
    // },
    isPendingStatus() {
      return this.editBroadcast.sent_status === '' || 
            (this.editBroadcast.sent_status !== 'done' && this.editBroadcast.sent_status !== 'none');
    },
    isCompletedStatus() {
      return this.editBroadcast.sent_status === 'done' || this.editBroadcast.sent_status === 'none';
    },
    senderIDs() {
      if(this.smsSocialData?.sender_ids?.length) {
        return this.smsSocialData?.sender_ids || [];
      }
      return [];
    },
    instructions() {
      if (this.selectedBroadCastChannel === 'email') {
        return {
          Email: "Recipient's Email address",
        };
      }
      return {
        Countrycode: "Mobile number country code (eg.: '65' for Singapore)",
        MobileNumber: "Mobile number"
      };
    }
  },
  mounted() {
    this.clearBroadcast();
    this.fetchInitialData();
    this.onPageLoad();
    this.abTestingOn = !!this.editBroadcast?.distribution_probability;
    document.addEventListener( "broadcast-update", this.updateBroadcastStatus, true );
  },
  ionViewWillEnter() {
    this.onPageLoad();
    this.setMessageTags();
    // The page is kept alive by Ionic's router outlet, so mounted() does not
    // re-run after a shop switch. Re-fetch if the active shop changed since the
    // last load so we don't show the previous shop's broadcasts.
    const currentShop = useAuthStore().cleanUserData?.referallshopName;
    if (currentShop !== this.loadedForShop) {
      this.loadedForShop = currentShop;
      // Clear local state, then reload the lists for the newly selected shop.
      this.allbroadcasts = [];
      this.fetchBroadcasts();
      if (this.draftBroadcastsFetched) {
        this.fetchDraftBroadcasts();
      }
    }
  },
  beforeUnmount() {
    this.stopPolling(); // Clean up interval when component is destroyed
    document.removeEventListener( "broadcast-update", this.updateBroadcastStatus, true );
  },
  watch: {
    broadcastIndexToEdit: {
      handler: function() {
        // Only reset settings if creating a new broadcast (broadcastIndexToEdit === -1)
        // For editing existing broadcasts, let preloadEditValues() handle the restoration
        if (this.broadcastIndexToEdit === -1) {
          this.resetSettings();
        }
        this.editBroadcastObjectHandler();
      },
      immediate: true
    },
      broadcastFilter(val) {
      if (!val || val === '') {
        this.fetchBroadcasts();
      }
    },
    draftBroadcastFilter(val) {
      if (!val || val === '') {
        this.fetchDraftBroadcasts();
      }
    },
    "editBroadcast.file_path"() {
      if (this.editBroadcast.file_path && this.editBroadcast.file_path.length)
        this.sendMode = "csv";
    },
    "editBroadcast.send_date_time"() {
      // Don't auto-set to 'later' when duplicating a broadcast
      if (this.editBroadcast.id && this.editBroadcast.send_date_time && !this.isDuplicateBroadcast) {
        this.sendNow = 'later';
      }
    },
    sendNow(newValue) {
      // Ensure timezone is set when switching to "send later"
      if (newValue === 'later' && !this.editBroadcast.timezone) {
        this.editBroadcast.timezone = useAuthStore().cleanUserData?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    },
    "editBroadcast.targeting_conditions": {
      handler: function(newValue) {
        if (newValue && newValue.length) {
          if (newValue[0].operator === "and") this.filterConditions = "and";
          else this.filterConditions = "or";
        }
      },
      deep: true,
    },
    targetingOption: {
      async handler(newValue, oldValue) {
        // Reset targeting count when targeting option changes
        if (newValue !== oldValue && this.$refs.SegmentsTargetingCount) {
          this.$refs.SegmentsTargetingCount.targetedCustomerCount = '-';
        }
        // Always refresh segments when user selects segment targeting so newly
        // created segments are available without a full page reload.
        if (newValue === 'SELECT_SEGMENT') {
          await this.fetchSegments();
        }
      },
      immediate: false
    },
    "editBroadcast.id"() {
      if(this.editBroadcast.id) {
        this.fetchTemplatesForViewMode()
      }
    },
    allLanguages: {
      handler: function(newVal) {
        if (newVal && newVal.length)
          this.editBroadcast.wa_language = this.allLanguages[0];
      },
      deep: true,
    },
  },
  methods: {
    moment,
    isTranscodeEnabledForSms,
    fetchInitialData() {
      this.loadedForShop = useAuthStore().cleanUserData?.referallshopName;
      this.fetchBroadcasts();
    },
    onRangeUpdate({ range, selectedOption, distributionProbability }) {
      this.abTestingOn = selectedOption;
      if(!this.abTestingOn) {
        this.activeTabAbTesting = VERSION_A
      }
      this.distributionRange = range;
      this.editBroadcast.distribution_probability = distributionProbability;
    },
    onClickAddConditionButton({ actionMenuPosition }) {
      this.segmentActionPosition.top = actionMenuPosition.top + 5;
      this.segmentActionPosition.left = actionMenuPosition.left - 2;
      this.segmentActionPosition.width = actionMenuPosition.width;
      this.showSegmentActions = true;
    },
    onActionClick(option) {
      this.showSegmentActions = false;
      this.$refs.CustomerSegments.addCondition(option);
    },
    filteredChannels(channel) {
      return this.availableCategories.filter(obj => obj.value === channel)
    },
    onPageLoad() {
      this.clearBroadcast();
      this.isTemplateLoading = false,
      this.isTemplateLoading_B = false,
      this.isDuplicateBroadcast = false;
      this.iseditDraftbroadcast = false;
      this.objWhatsAppPreview_A = {};
      this.objWhatsAppPreview_B = {};
      this.allTemplateData_A = {};
      this.allTemplateData_B = {};
      this.template_subtype_A = '';
      this.template_subtype_B = '';
      this.broadcastIndexToEdit = -1;
      this.selectedAccordion = 'select_channel';
      this.editBroadcast = { ...editBroadcast };
      this.editMode = false;
      this.showMessages = false;
      this.fallbackMessagePayload = '';
    },
    onChangeChannel() {
      this.resetUploadedFileObject();
      this.targetingOption = 'SELECT_FILTERS';
      // Reset template subtypes when changing channels
      this.template_subtype_A = '';
      this.template_subtype_B = '';
      this.allTemplateData_A = {};
      this.allTemplateData_B = {};
      this.objWhatsAppPreview_A = {};
      this.objWhatsAppPreview_B = {};
      this.$refs.JsonBuilderWrapper_A?.clearElements();
      this.$refs.JsonBuilderWrapper_B?.clearElements();
    },
    callFetchTargetedCustomerCount() {
      let formattedConditionJson;
      if (this.targetingOption == 'SELECT_SEGMENT') {
        if (!this.selectedSegment?.id) {
          return useUIStore().updateToast({ open: true, message: "Please select valid segment!", type: "danger" });
        } else {
          formattedConditionJson = this.selectedSegment.targeting_conditions;
          this.$refs.SegmentsTargetingCount.fetchTargetedCustomerCount(formattedConditionJson, 'broadcast');
        }
      } else {
        const isValid = this.$refs.CustomerSegments.validateConditions();
        if (!isValid) {
          return;
        }
        const queryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();
        if (queryString?.length) {
          this.$refs.SegmentsTargetingCount.fetchTargetedCustomerCountByQueryString(queryString, 'broadcast');
        } else {
          useUIStore().updateToast({ open: true, message: "Minimum one condition is required for segment.", type: "danger", });
        }
      }
    },
    broadcastExecuted_30mins_later(last_sent, created, timezone) {
        if (typeof created != 'undefined') {
          let executedDate_tz = useAuthStore().cleanUserData?.timezone;
          let executedDate = "";
          if (typeof timezone != 'undefined' && timezone != '' && timezone != 'None' && timezone != null) {
            executedDate_tz = timezone;
          }
          if (typeof last_sent != 'undefined' && last_sent != '' && last_sent != 'None' && last_sent != null) {
            executedDate = last_sent;
          }
          else {
            executedDate = created;
          }
          const startDate = moment(executedDate).tz(executedDate_tz);
          const endDate = moment().tz(executedDate_tz);
          if (endDate.diff(startDate, 'minutes') >= 30) {
            return true;
          } else {
            return false;
          }
        }
    },
    async preloadEditValues() {
      this.availableCategories.forEach((channel) => {
        if (channel.value == this.editBroadcast.channel) {
          this.selectedBroadCastChannel = channel.value;
        }
      });
      if (this.editBroadcast.segmentid) {
        this.targetingOption = 'SELECT_SEGMENT';
        await this.fetchSegments();
        this.selectedSegment = this.filteredSegments.find(segment => String(segment.id) === String(this.editBroadcast.segmentid)) || null;
      } else if (this.editBroadcast?.targeting_conditions?.length) {
        this.targetingOption = 'SELECT_FILTERS';
      } else if (this.editBroadcast?.file_path?.trim()) {
        this.targetingOption = UPLOAD_FILE;
        this.uploadedFileObject.filePath = this.editBroadcast?.file_path;
        this.uploadedFileObject.fileName = this.getUploadecCSVFilename(this.editBroadcast?.file_path);
      }
      this.abTestingOn = !!this.editBroadcast.distribution_probability?.trim();
      if (this.editBroadcast?.sender_id == null) {
        this.selectSMSSenderID = 'custom';
      } else {
        this.selectSMSSenderID = this.editBroadcast?.sender_id;
      }
      // Restore the email sender for an existing/duplicated email broadcast.
      // email_sender_id is stored as "email:DisplayName"; match on the email part.
      // An explicit null (the "Custom" option) restores as 'custom', mirroring SMS.
      if (this.editBroadcast?.channel === 'email') {
        if (this.editBroadcast?.email_sender_id) {
          const savedEmail = String(this.editBroadcast.email_sender_id).split(':')[0];
          const match = this.senderEmails.find(s => s.email === savedEmail);
          this.selectEmailSender = match ? match.email : (this.senderEmails[0]?.email || '');
        } else if (this.editBroadcast?.email_sender_id === null) {
          this.selectEmailSender = 'custom';
        } else if (this.senderEmails.length > 0) {
          this.selectEmailSender = resolveDefaultSenderEmail(this.senderEmails, this.emailSocialData);
        }
        // Build email_data from the saved broadcast so EmailCreateMessage/EmailPreview
        // pre-fill subject + body when editing or viewing. The API returns the body in
        // answers[0].message (message_type "html" | "text") and the subject at top level.
        this.hydrateEmailDataFromBroadcast();
      }
      const failoverAnswers = this.editBroadcast?.failover_answers ?? [];
      if(failoverAnswers.length  > 0) {
        this.enableFallBackMessage = true;
        this.fallbackMessagePayload = this.editBroadcast.failover_answers[0].message;
      }
      if(this.isDuplicateBroadcast){
        this.editBroadcast.name = this.getNewBroadcastName();
        // Clear the ID and send_date_time first to prevent watchers from interfering
        this.editBroadcast.id = undefined;
        this.editBroadcast.send_date_time = '';
        // For duplicated broadcasts, always default to 'now' unless it's a draft being duplicated to stay as draft
        if(this.iseditDraftbroadcast){
          this.sendNow = 'draft';
        } else {
          this.sendNow = 'now';
        }
        this.editBroadcast.timezone = useAuthStore().cleanUserData?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      // Initialize finalUrlType from API data
      if (this.editBroadcast?.url_types?.HEADER?.[0]) {
        this.finalUrlType = this.editBroadcast.url_types.HEADER[0];
      }
      // Initialize finalUrlType_B from API data for A-B testing
      if (this.editBroadcast?.url_types_b?.HEADER?.[0]) {
        this.finalUrlType_B = this.editBroadcast.url_types_b.HEADER[0];
      }
    },
    resetSettings() {
      this.targetingOption = 'SELECT_FILTERS';
      this.resetUploadedFileObject();
      this.activeTabAbTesting = VERSION_A;
      this.abTestingOn = false;
      this.enableFallBackMessage = false;
      this.fallbackMessagePayload = '';
      // Reset scheduling. When creating from the Drafts tab, default to
      this.sendNow = this.activeListingTab === 'draft_broadcast' ? 'draft' : 'now';
      // Reset template subtypes to clear previous template type (e.g., LTO)
      this.template_subtype_A = '';
      this.template_subtype_B = '';
      this.allTemplateData_A = {};
      this.allTemplateData_B = {};
      this.objWhatsAppPreview_A = {};
      this.objWhatsAppPreview_B = {};
      if (Array.isArray(this.senderIDs) && this.senderIDs.length > 0) {
        const defaultSenderId = this.smsSocialData?.default_sender_id;
        this.selectSMSSenderID = defaultSenderId && this.senderIDs.includes(defaultSenderId)
          ? defaultSenderId
          : this.senderIDs[0];
      } else {
        this.selectSMSSenderID = '';
      }
      // Set default email sender
      if (Array.isArray(this.senderEmails) && this.senderEmails.length > 0) {
        // default_sender_id may be in "email:DisplayName" format; match on the email part.
        this.selectEmailSender = resolveDefaultSenderEmail(this.senderEmails, this.emailSocialData);
      } else {
        this.selectEmailSender = '';
      }
    },
    async onListViewEdit({ index, isDraft }) {
      this.editMode = true;
      this.broadcastIndexToEdit = index;
      // Normal edit: ensure correct mode flags
      this.iseditDraftbroadcast = !!isDraft;
      this.isDuplicateBroadcast = false;
      this.fetchAllTemplatesData();
    },
    async onListDuplicate({ index, isDraft }) {
      this.editMode = true;
      this.broadcastIndexToEdit = index;
      // Duplicate mode: mark duplicate and normalize draft flag
      this.isDuplicateBroadcast = true;
      this.iseditDraftbroadcast = !!isDraft;
      this.fetchAllTemplatesData();
    },
    async onClickAddNewBroadcast() {
      this.editMode = true;
      this.showMessages = true;
      // New broadcast should not be treated as draft edit or duplicate
      this.iseditDraftbroadcast = false;
      this.isDuplicateBroadcast = false;
      this.fetchAllTemplatesData();
      this.resetSettings();
      this.editBroadcastObjectHandler();
    },
    getNewBroadcastName() {
      const generateRandomName = () => {
        const randomNumber = Math.floor(Math.random() * 99999) + 1;
        return `Broadcast ${randomNumber}`;
      };

      // Get all existing broadcast names for collision checking
      const allExistingNames = new Set();
      
      // Add current broadcasts
      if (this.allbroadcasts) {
        this.allbroadcasts.forEach(item => {
          if (item.name) allExistingNames.add(item.name);
        });
      }
      
      // Add draft broadcasts
      if (this.allDraftBroadcasts) {
        this.allDraftBroadcasts.forEach(item => {
          if (item.name) allExistingNames.add(item.name);
        });
      }

      // Generate a unique name
      let newName = generateRandomName();
      let attempts = 0;
      const maxAttempts = 50; // Prevent infinite loop
      
      while (allExistingNames.has(newName) && attempts < maxAttempts) {
        newName = generateRandomName();
        attempts++;
      }
      
      // Fallback if we couldn't generate a unique name
      if (attempts >= maxAttempts) {
        const timestamp = Date.now();
        newName = `Broadcast ${timestamp}`;
      }

      return newName;
    },
    async editBroadcastObjectHandler() {
      this.reloadCustomerSegments = false;
      if (this.broadcastIndexToEdit > -1) {
        if(this.iseditDraftbroadcast) {
          this.editBroadcast = { ...this.draftBroadcastsToShow[this.broadcastIndexToEdit] };
          // Only set sendNow to 'draft' if NOT duplicating
          if (!this.isDuplicateBroadcast) {
            this.sendNow = 'draft';
          }
        } else {
          this.editBroadcast = { ...this.broadcastsToShow[this.broadcastIndexToEdit] };
        }
        const broadcastDetails = await this.getBroadcastDetailsviaID(this.editBroadcast.id);
        if (broadcastDetails) {
          this.editBroadcast = { ...this.editBroadcast, ...broadcastDetails };
          this.componentKey++
        }
        this.showMessages = true;
        await this.preloadEditValues();
      } else {
        this.editBroadcast = { ...editBroadcast, ...{ name: this.getNewBroadcastName(), timezone: useAuthStore().cleanUserData?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone } };
        setTimeout(() => {
          this.selectedBroadCastChannel = this.channelsToRender[0]?.value;
        }, 500);
        if (Array.isArray(this.senderIDs) && this.senderIDs.length > 0) {
          const defaultSenderId = this.smsSocialData?.default_sender_id;
          this.selectSMSSenderID = defaultSenderId && this.senderIDs.includes(defaultSenderId)
            ? defaultSenderId
            : this.senderIDs[0];
        }
        this.editBroadcast.channel = this.channelsToRender[0]?.value;
      }
      this.selectedAccordion = 'select_channel';
      this.$nextTick(() => {
        this.reloadCustomerSegments = true;
      });
    },
    doRefresh(e) {
      e.target.complete();
    },
    onSelectBroadCastChannel(thisCategory) {
      this.selectedBroadCastChannel = thisCategory.value;
      this.editBroadcast.channel = thisCategory.value;
      this.showCustomerSegments = false;
      setTimeout(() => {
        this.showCustomerSegments = true;
      }, 500);
    },
    async onSelectUploadFile(event) {
      try {
        const fileToSend = event.target.files[0];
        let $this = this;
        if (fileToSend && fileToSend.name.lastIndexOf(".csv") !== -1) {
          let newCsv = new FileReader();
          newCsv.readAsText(fileToSend);
          newCsv.onload = function (event) {
            let csv = event.target.result;
            let lines = csv.split("\n");
            // Validating for rows max 100k
            if (lines.length > 100000) {
              useUIStore().updateToast({ open: true, message: "The CSV file should not exceed 100,000 customers", type: "danger", });
              return;
            }
            let headers = lines[0].split(",");
            if (headers.length < 4) {
              useUIStore().updateToast({ open: true, message: "There should be atleast 4 columns in CSV", type: "danger", });
              return;
            }
            $this.csvToUpload = fileToSend;
          };
          newCsv.onerror = function () {
            this.csvToUpload = undefined;
            useUIStore().updateToast({ open: true, message: "Unable to read " + fileToSend.name, type: "danger", });
          };
        } else {
          this.csvToUpload = undefined;
          useUIStore().updateToast({ open: true, message: "Please add a valid CSV", type: "danger", });
        }
      } catch (error) {
        console.error("Exception", error);
        useUIStore().updateToast({ open: true, message: "Something went wrong", type: "danger", });
      }
    },
    // loadMore = true appends the next cursor page; false (re)loads page one.
    async fetchBroadcasts(loadMore = false) {
      // Ignore repeat clicks while a page is still in flight, and stop once
      // the API has told us there is nothing left to fetch.
      if (this.broadcastsLoadMore) return;
      if (loadMore && !this.broadcastsNextCursor) return;
      try {
        let reqBody = { limit: 100 };
        if (loadMore) {
          reqBody.cursor = this.broadcastsNextCursor; // Adding cursor only for pagination
        }
        if (loadMore) {
          this.broadcastsLoadMore = true;
        } else {
          useUIStore().updateLoading({ isLoading: true, message: 'Loading broadcasts...' });
        }
        const params = {
          ...reqBody
        }
        let allbroadcastsResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "broadcasts/v1/broadcasts", { params } );
        if (loadMore) {
          this.allbroadcasts = this.allbroadcasts.concat(allbroadcastsResponse);
        } else {
          this.allbroadcasts = allbroadcastsResponse;
        }
        // next_cursor is attached to the response payload by apiInterceptor.
        this.broadcastsNextCursor = allbroadcastsResponse.next_cursor;
        this.canLoadMoreBroadcasts = !!this.broadcastsNextCursor;
        this.allbroadcasts = this.allbroadcasts.slice();
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        if (loadMore) {
          this.broadcastsLoadMore = false;
        } else {
          useUIStore().updateLoading({ isLoading: false });
        }
      }
    },
    async debouncedBroadcastSearch() {
      try {
        if (!this.broadcastFilter || this.broadcastFilter.trim() === "") {
          // If search is empty, fetch all broadcasts
          await this.fetchBroadcasts();
          return;
        }
        useUIStore().updateLoading({ isLoading: true, message: 'Searching broadcasts...' });
        const response = await apiInterceptor.get(environment("VUE_APP_API_URL") + "broadcasts/v1/broadcasts/s/", { params: { name: this.broadcastFilter, detail: 'minimum'} });
        this.allbroadcasts = response;
        // Search results are not cursor paginated — drop any cursor held from
        // the unfiltered list so load-more can't append a stale page.
        this.broadcastsNextCursor = undefined;
        this.canLoadMoreBroadcasts = false;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async debouncedDraftBroadcastSearch() {
      try {
        if (!this.draftBroadcastFilter || this.draftBroadcastFilter.trim() === "") {
          // If search is empty, fetch all drafts
          await this.fetchDraftBroadcasts();
          return;
        }
        useUIStore().updateLoading({ isLoading: true, message: 'Searching broadcasts...' });
        const response = await apiInterceptor.get(environment("VUE_APP_API_URL") + "broadcasts/v1/drafts/s/", { params: { name: this.draftBroadcastFilter, detail: 'minimum'} });
        this.allDraftBroadcasts = response;
        // Search results are not cursor paginated — drop any cursor held from
        // the unfiltered list so load-more can't append a stale page.
        this.draftBroadcastsNextCursor = undefined;
        this.canLoadMoreDraftBroadcasts = false;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    // loadMore = true appends the next cursor page; false (re)loads page one.
    async fetchDraftBroadcasts(loadMore = false) {
      if (this.draftBroadcastsLoadMore) return;
      if (loadMore && !this.draftBroadcastsNextCursor) return;
      try {
        let reqBody = { limit: 100 };
        if (loadMore) {
          reqBody.cursor = this.draftBroadcastsNextCursor; // Adding cursor only for pagination
        }
        if (loadMore) {
          this.draftBroadcastsLoadMore = true;
        } else {
          useUIStore().updateLoading({ isLoading: true, message: 'Loading broadcasts...' });
        }
        const params = {
          ...reqBody
        }
        let allDraftbroadcastsResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "broadcasts/v1/drafts", { params } );
        if (loadMore) {
          this.allDraftBroadcasts = this.allDraftBroadcasts.concat(allDraftbroadcastsResponse);
        } else {
          this.allDraftBroadcasts = allDraftbroadcastsResponse;
        }
        // next_cursor is attached to the response payload by apiInterceptor.
        this.draftBroadcastsNextCursor = allDraftbroadcastsResponse.next_cursor;
        this.canLoadMoreDraftBroadcasts = !!this.draftBroadcastsNextCursor;
        this.allDraftBroadcasts = this.allDraftBroadcasts.slice();
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        if (loadMore) {
          this.draftBroadcastsLoadMore = false;
        } else {
          useUIStore().updateLoading({ isLoading: false });
        }
      }
    },
    async deleteBroadcast() {
      try {
        // Capture the index and close the confirm dialog first so it doesn't
        // sit in front of the loader while the delete runs.
        const deleteIndex = this.broadcastIndexToDelete;
        const thisBroadcastToDelete = this.broadcastsToShow[deleteIndex];
        this.broadcastIndexToDelete = -1;
        useUIStore().updateLoading({ isLoading: true, message: 'Deleting broadcast...' });
        await apiInterceptor.delete( environment("VUE_APP_API_URL") + "broadcasts/v1/broadcasts/" + thisBroadcastToDelete.id );
        useUIStore().updateToast({ open: true, message: "Broadcast deleted successfully", type: "success", });
        this.allbroadcasts.splice(deleteIndex, 1);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.broadcastIndexToDelete = -1;
      }
    },
    async deleteDraftBroadcast() {
      try {
        // Capture the index and close the confirm dialog first so it doesn't
        // sit in front of the loader while the delete runs.
        const deleteIndex = this.draftbroadcastIndexToDelete;
        const thisBroadcastToDelete = this.draftBroadcastsToShow[deleteIndex];
        this.draftbroadcastIndexToDelete = -1;
        useUIStore().updateLoading({ isLoading: true, message: 'Deleting draft broadcast...' });
        await apiInterceptor.delete( environment("VUE_APP_API_URL") + "broadcasts/v1/drafts/" + thisBroadcastToDelete.id );
        useUIStore().updateToast({ open: true, message: "Draft Broadcast deleted successfully", type: "success", });
        this.allDraftBroadcasts.splice(deleteIndex, 1);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.draftbroadcastIndexToDelete = -1;
      }
    },
    // Utility: Remove only leading and trailing newlines (and spaces), keep newlines in the middle
    cleanPayload(payload) {
      if (typeof payload !== 'string') return payload;
      // Remove leading/trailing newlines and spaces, but keep newlines in the middle
      return payload.replace(/^[\s\n]+|[\s\n]+$/g, '');
    },
    getAdMessageJson(version, isValidation) {
      const adMessageElement = (version == VERSION_A ? this.adMessageJsonElements_A[0] : this.adMessageJsonElements_B[0]) || {};
      const { type, payload, buttons, title, subtitle, fileName, contentType,  fileExtension   } = adMessageElement;
      let adMessageJson = {};
      switch (type) {
        case 'text':
          if (buttons?.length) {
            let buttonsToUse = [];
            buttons.forEach((elm) => {
              let elmButton = {
                title: elm.text,
                description: elm.text,
                type: elm.type,
              }
              if (elm.payload) {
                elmButton.payload = elm.payload;
              } else if(elm.url) {
                elmButton.url = elm.url;
                elmButton.height_ratio = "full";
              } else {
                elmButton.url = elm.url;
                elmButton.height_ratio = "full";
              }
              buttonsToUse.push(elmButton);
            });

            adMessageJson = [
              {
                message: [payload],
                template_type: "buttonreply",
                template: { buttons: buttonsToUse }
              }
            ]
          } else {
            // Remove only leading and trailing newlines, not those in the middle
            const cleanedPayload = this.cleanPayload(payload);
            adMessageJson = [{
              message: [cleanedPayload],
              template_type: "normalchat"
            }]
          }
        break;
        case 'sms':
          if (buttons?.length) {
            let buttonsToUse = [];
            buttons.forEach((elm) => {
              let elmButton = {
                title: elm.text,
                description: "Button",
                type: "postback",
              }
              if (elm.payload) {
                elmButton.payload = elm.payload;
              } else {
                elmButton.url = "";
                elmButton.height_ratio = "full"
              }
              buttonsToUse.push(elmButton);
            });

            adMessageJson = [
              {
                message: [payload],
                template_type: "buttonreply",
                template: {buttons: buttonsToUse}
              }
            ]
          } else {
          const cleanedPayload = this.cleanPayload(payload);
          adMessageJson = [{
            message: [cleanedPayload],
            template_type: "normalchat"
            }]
          }
          break;
        case 'image':
          adMessageJson = [{
            message: [payload || ""],
            template_type: "cancelled"
          }]
        break;
        case 'video':
          adMessageJson = [
            {
              message: [ payload || "" ],
              template_type: "videoreply",
              mediatype: "video"
            }
          ];
          break;
        case 'document':
          adMessageJson = [
            {
              message: [ payload || "" ],
              template_type: "document",
              mediatype: "document",
              documentname: fileName,
              documenturl: payload,
              contenttype: contentType,
              extension: fileExtension,
            }
          ];
          break;
        case 'carousel':
        case 'richcard': {
          adMessageJson = version === VERSION_A ? this.rcsCarouselData_A : this.rcsCarouselData_B;
          for (const item of adMessageJson) {
            // Handle each element inside the carousel
            if (item.template?.elements) {
              for (const element of item.template.elements) {
                // Thumbnail alignment based on card_orientation
                if (element?.extrainfo?.card_orientation === "VERTICAL") {
                  delete element.extrainfo.thumbnail_alignment;
                } else if (element?.extrainfo?.card_orientation === "HORIZONTAL") {
                  delete element.extrainfo.height;
                }
                // Handle calendar formatting inside element.buttons
                if (element.buttons && !isValidation) {
                  for (const button of element.buttons) {
                    if (button.type === "calendar" && button.payload) {
                      const result = this.formatDateTimeToISOString(button.payload);
                      if (result && result.error) {
                        console.error("Payload formatting failed:", result.error);
                        return;
                      } else {
                        button.payload = result;
                      }
                    }
                  }
                }
              }
            }
            if (item.template?.buttons) {
              for (const button of item.template.buttons) {
                if (button.text) {
                  button.title = button.text;
                  delete button.text;
                }
                if (button.type === "calendar" && button.payload && !isValidation) {
                  const result = this.formatDateTimeToISOString(button.payload);
                  if (result && result.error) {
                    console.error("Payload formatting failed:", result.error);
                    return;
                  } else {
                    button.payload = result;
                  }
                }
              }
            }
          }
          break;
        }
        case 'reply': {
          const buttonsToUse = [];
          for (const elm of buttons) {
            const { text, payload, extrainfo, type, url, url_type, postback_action_type, postback_action } = elm;

            const buttonObj = {
              title: text,
              description: text,
            };

            if (type) {
              buttonObj.type = type;

              if (type === 'calendar') {
                const result = this.formatDateTimeToISOString(payload);
                if (result && result.error) {
                  console.error("Payload formatting failed:", result.error);
                  return;
                } else {
                  buttonObj.payload = result;
                }
              } else if (type === 'webview' || type === 'app_webview') {
                buttonObj.url = url;
                buttonObj.payload = url;
                buttonObj.url_type = url_type;
              } else if (payload) {
                buttonObj.payload = payload;
              }
            } else if (payload) {
              buttonObj.payload = payload;
            }

            if (extrainfo) {
              buttonObj.extrainfo = extrainfo;
            }

            if (postback_action_type) {
              buttonObj.postback_action_type = postback_action_type;
            }

            if (postback_action) {
              buttonObj.postback_action = postback_action;
            }

            buttonsToUse.push(buttonObj);
          }

          adMessageJson = [
            {
              message: [payload],
              template_type: "quickreplies",
              template: {
                buttons: buttonsToUse
              }
            }
          ];
        }
        break;
        default:
        break;
      }
      return adMessageJson;
    },
    // Build the email `messages` array from the EmailCreateMessage component data.
    // Returns undefined when the email component/ref is unavailable.
    getEmailMessagesJson(version) {
      const emailRef = version == VERSION_B ? this.$refs.emailCreateMessage_B : this.$refs.emailCreateMessage_A;
      const emailData = emailRef?.getEmailData ? emailRef.getEmailData() : (version == VERSION_B ? this.emailData_B : this.emailData_A);
      if (!emailData) {
        return undefined;
      }
      // HTML editor (both the Visual and HTML Source sub-tabs) sends message_type "html".
      // Only the dedicated Plain Text Editor sends "text".
      return [buildEmailMessage(emailData)];
    },
    getFormattedMessageRequestBody() {
      let reqBody, messages;
      try {
        // Email channel builds its own payload shape (subject/importance/priority/sensitivity).
        if (this.editBroadcast.channel === 'email') {
          return this.getFormattedEmailRequestBody();
        }
        messages = this.getAdMessageJson(VERSION_A, false);
        if (messages === undefined) {
          return;
        } else {
        reqBody = {
          channel: this.editBroadcast.channel,
          name: this.editBroadcast.name,
          mode: this.sendNow == 'now' ? "send" : this.sendNow == 'later' ?  "save" : "draft",
          pageid: JSON.stringify(this.selectSocialPageId),
          url_types: {"HEADER": [this.finalUrlType]},
        };
        if(this.sendTag !== undefined) {
          reqBody.sendTag = this.sendTag
        }
        // A-B testing parameters
        if( this.abTestingOn ) {
          const adMessageJsonB = this.getAdMessageJson(VERSION_B, false);
          if (adMessageJsonB === undefined) {
            return;
          } else {
            reqBody.messagelisted = adMessageJsonB || [];
            reqBody.messages = messages;
            // Set message_type for Version B
            if(reqBody.messagelisted?.length > 0){
              const elementType_B = this.adMessageJsonElements_B[0]?.type;
              reqBody.messagelisted[0].message_type = elementType_B === 'richcard' ? 'richcard' : (adMessageJsonB[0]?.template_type?.includes('carousel') ? 'carousel' : adMessageJsonB[0]?.template_type);
            }
            if(reqBody.messages?.length > 0){
              const elementType_A = this.adMessageJsonElements_A[0]?.type;
              reqBody.messages[0].message_type = elementType_A === 'richcard' ? 'richcard' : (messages[0]?.template_type?.includes('carousel') ? 'carousel' : messages[0]?.template_type);
            }
            reqBody.distribution_probability = this.editBroadcast.distribution_probability;
            reqBody.url_types_b = {"HEADER": [this.finalUrlType_B]}; // Only add when A-B testing is on
          }
        } else {
          reqBody.messages = messages;
          if(reqBody.messages?.length > 0){
            const elementType = this.adMessageJsonElements_A[0]?.type;
            reqBody.messages[0].message_type = elementType === 'richcard' ? 'richcard' : (messages[0]?.template_type?.includes('carousel') ? 'carousel' : messages[0]?.template_type);
          }
        }

        // set params for send later
        if(this.sendNow == 'later') {
          reqBody.timezone = this.editBroadcast.timezone;
          reqBody.send_date_time = moment(this.editBroadcast.send_date_time).format('DD/MM/YYYY HH:mm:ss');
        }

        // set targeting conditions
        if (this.targetingOption == 'SELECT_SEGMENT') {
          reqBody.segmentid = `${this.selectedSegment.id}`;
        } else {
          const queryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();
          reqBody.targeting_conditions = parseTargetingConditions(queryString, useAuthStore().authData?.userId);
        }

        // in case edit mode pass broadcast id
        if (this.editBroadcast?.id && !this.isDuplicateBroadcast) {
          reqBody.id = this.editBroadcast?.id;
        }
        //FallBack Message 
        if(this.enableFallBackMessage) {
          this.finalFallBackMessageArray[0].message = [];
          this.finalFallBackMessageArray[0].message.push(this.fallbackMessagePayload);
          reqBody.failover_messages = this.finalFallBackMessageArray;
        }
        // for Google RCS Document Upload
        if(messages[0].template_type == 'document' && this.editBroadcast.channel === 'googlercs') {
          reqBody.documenturl = messages.documenturl;
          reqBody.documentname = messages.documentname;
          reqBody.contenttype = messages.contenttype;
          reqBody.extension = messages.extension;
        }
        reqBody.sender_id = this.selectSMSSenderID === 'custom' ? null : this.selectSMSSenderID; // sms senderID
      }
      } catch (error) {
        console.error(error);
        useUIStore().updateToast({ open: true, message: "Something went wrong", type: "danger", });
        throw new Error('Something went wrong');
      }
      return reqBody;
    },
    // Build request body for the email channel (segment/filter targeting path).
    getFormattedEmailRequestBody() {
      let reqBody;
      try {
        const messages = this.getEmailMessagesJson(VERSION_A);
        if (messages === undefined) {
          return;
        }
        reqBody = {
          channel: this.editBroadcast.channel,
          name: this.editBroadcast.name,
          mode: this.sendNow == 'now' ? "send" : this.sendNow == 'later' ? "save" : "draft",
          pageid: JSON.stringify(this.selectSocialPageId),
          messages,
          email_subject: messages[0]?.email_subject || '',
        };
        // Sender: "email:Display Name" / plain email, or null for the "Custom" option
        // (backend resolves per-contact). undefined means no selection -> omit the field.
        const emailSenderId = this.getFormattedEmailSenderId();
        if (emailSenderId !== undefined) {
          reqBody.email_sender_id = emailSenderId;
        }
        // A-B testing: send Version B as messagelisted plus the distribution split
        // (mirrors the whatsapp/rcs builder).
        if (this.abTestingOn) {
          const messagesB = this.getEmailMessagesJson(VERSION_B);
          if (messagesB === undefined) {
            return;
          }
          reqBody.messagelisted = messagesB;
          reqBody.distribution_probability = this.editBroadcast.distribution_probability;
        }
        // set params for send later
        if (this.sendNow == 'later') {
          reqBody.timezone = this.editBroadcast.timezone;
          reqBody.send_date_time = moment(this.editBroadcast.send_date_time).format('DD/MM/YYYY HH:mm:ss');
        }
        // set targeting conditions
        if (this.targetingOption == 'SELECT_SEGMENT') {
          reqBody.segmentid = `${this.selectedSegment.id}`;
        } else {
          const queryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();
          reqBody.targeting_conditions = parseTargetingConditions(queryString, useAuthStore().authData?.userId);
        }
        // in case edit mode pass broadcast id
        if (this.editBroadcast?.id && !this.isDuplicateBroadcast) {
          reqBody.id = this.editBroadcast?.id;
        }
      } catch (error) {
        console.error(error);
        useUIStore().updateToast({ open: true, message: "Something went wrong", type: "danger", });
        throw new Error('Something went wrong');
      }
      return reqBody;
    },
    // Resolve the optional custom email sender id in the "email:Display Name" format.
    getFormattedEmailSenderId() {
      return formatEmailSenderId(this.selectEmailSender, this.senderEmails);
    },
    // Map a saved email broadcast (edit/view) into the email_data shape consumed by
    // EmailCreateMessage.populateFromBroadcast and the EmailPreview (via emailData_A).
    hydrateEmailDataFromBroadcast() {
      const emailData = mapEmailDataFromBroadcast(this.editBroadcast);
      // Attach so the child watcher (immediate + deep) picks it up on mount.
      this.editBroadcast.email_data = emailData;
      // Seed the preview immediately (EmailCreateMessage also emits this on populate).
      this.emailData_A = {
        subject: emailData.subject,
        body: emailData.body,
        editor_type: emailData.editor_type,
        properties: emailData.properties,
      };
      // A/B testing: seed the Version B preview from the saved Version B content
      // (answerlisted / messagelisted). The Version B EmailCreateMessage hydrates
      // via the editBroadcast_version_B computed's email_data.
      if (this.abTestingOn) {
        const emailDataB = mapEmailDataFromBroadcastVersionB(this.editBroadcast);
        this.emailData_B = {
          subject: emailDataB.subject,
          body: emailDataB.body,
          editor_type: emailDataB.editor_type,
          properties: emailDataB.properties,
        };
      }
    },
    // non whatsapp channels validation version A
    validateNonWaChannels(version) {
      const $refJsonBuilderWrapper = version == VERSION_A ? this.$refs.JsonBuilderWrapper_A : this.$refs.JsonBuilderWrapper_B;
      const adMessageJsonElements =  version == VERSION_A ? this.adMessageJsonElements_A : this.adMessageJsonElements_B;

      if (!$refJsonBuilderWrapper?.messageType ) {
        return "Please select message type!";
      }
      const messages = this.getAdMessageJson(version, true);
      if (messages === undefined) {
        return;
      } else {
      if(this.editBroadcast.channel === 'googlercs' && (messages[0].template_type == 'carousel' || messages[0].template_type == 'quickcarousel' || messages[0].template_type == 'richcard')){
        const elements = messages?.[0]?.template?.elements;
        const quickReplybuttons = messages?.[0]?.template?.buttons;
        if (elements) {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            if (!element.title?.trim()) {
              return `Please enter a title for carousel ${i + 1} and try again!`;
            }
            if (!element.subtitle?.trim()) {
              return `Please enter a description for carousel ${i + 1} and try again!`;
            }
            if (element.buttons) {
              for (const button of element.buttons) {
                const validationError = this.validateCalendarButton(button);
                if (validationError) {
                  return validationError;
                }
              }
            }
          }
        }
        if(quickReplybuttons){ // calendar valiations for Quick reply
          for (const button of quickReplybuttons) {
          const validationError = this.validateCalendarButton(button);
          if (validationError) {
            return validationError;
          }
        }
        }
      }
      if (this.editBroadcast.channel === 'googlercs') {
        const defaultUrlType = version == VERSION_B ? (this.finalUrlType_B || 'static') : (this.finalUrlType || 'static');
        const invalidRcsButtonUrl = findInvalidRcsButtonUrl(messages, defaultUrlType);
        if (invalidRcsButtonUrl) {
          return "Please enter valid RFC 3986 URL(s) for all RCS URL buttons and try again!";
        }
      }
      if (!Array.isArray(messages) || messages.length === 0 || !messages[0]?.message || !Array.isArray(messages[0].message)) {
        return "Please create message inside create message section!";
      }
      const messageContent = messages[0].message[0];
      const templateType = messages[0].template_type;
      // Check for empty message
      if ([undefined, null].includes(messageContent)) {
        return "Please enter message inside create message section!";
      }

      // Validate media URL-based templates for static urls
      const mediaTemplates = ["cancelled", "videoreply", "document"];
      if (mediaTemplates.includes(templateType)) {
        let isValidUrl = true;
        if (this.editBroadcast.channel === 'googlercs') {
          const selectedUrlType = version == VERSION_B ? (this.finalUrlType_B || 'static') : (this.finalUrlType || 'static');
          isValidUrl = validateRcsUrl(messageContent, selectedUrlType === 'dynamic');
        } else if(this.finalUrlType == 'static' && !this.abTestingOn){
          isValidUrl = typeof messageContent === "string" && messageContent.startsWith("http");
        }

        if (!isValidUrl) {
          // Customize error message based on template type
          if (templateType === "cancelled") {
            return "Please provide a valid image and try again!";
          } else if (templateType === "videoreply") {
            return "Please provide a valid video and try again!";
          } else if (templateType === "document") {
            return "Please provide a valid document and try again!";
          } else {
            return "Please provide a valid media and try again!";
          }
        }
      }

      // Handle text/quick reply templates
      const textBasedTemplates = ["quickreplies", "normalchat", "reply", "buttonreply"];
      if (textBasedTemplates.includes(templateType) && typeof messageContent === "string" && messageContent.trim() === "") {
        return "Please enter message inside create message section!";
      }

      if (!adMessageJsonElements?.[0]) {
        return "Please create message inside create message section!";
      }
      if (this.enableFallBackMessage && !this.fallbackMessagePayload?.trim()) {
        return "Please enter fallback message and try again!";
      }
    }
    },
    validateBroadcastBeforeSave() {
      const selectedBroadCastChannel = this.selectedBroadCastChannel || '';
      // ------------ primary validations -----------
      if (!this.editBroadcast.name.trim()) {
        useUIStore().updateToast({ open: true, message: "Please enter broadcast name!", type: "danger" });
        return false;
      }
      if (!selectedBroadCastChannel) {
        useUIStore().updateToast({ open: true, message: "Please select broadcast channel!", type: "danger" });
        return false;
      }

      if (this.targetingOption == 'SELECT_SEGMENT' && !this.selectedSegment?.id) {
        useUIStore().updateToast({ open: true, message: "Please select valid segment!", type: "danger" });
        return false;
      } else if (this.targetingOption == 'SELECT_FILTERS') {
        if (!this.$refs.CustomerSegments) {
          useUIStore().updateToast({ open: true, message: "Please set valid targeting conditions!", type: "danger" });
          return false;
        }
        const isValid = this.$refs.CustomerSegments.validateConditions();
        if (!isValid) {
          return false;
        }
        const queryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();
        if (!queryString?.length) {
          useUIStore().updateToast({ open: true, message: "Please set valid targeting conditions!", type: "danger" });
          return false;
        }

        if (!queryString?.includes('platform')) {
          useUIStore().updateToast({ open: true, message: "Please add interaction channel in tergeting conditions!", type: "danger" });
          return false;
        }
      }

      if (this.targetingOption == UPLOAD_FILE && this.uploadedFileObject.filePath == '') {
        useUIStore().updateToast({ open: true, message: "Please select valid csv file!", type: "danger" });
        return false;
      }

      if (this.sendNow == 'later') {
        // Check if a valid schedule time is provided
        if (!this.editBroadcast?.send_date_time) {
          useUIStore().updateToast({ open: true, message: "Please select a valid schedule time.", type: "danger" });
          return false;
        }
        if (!this.editBroadcast?.timezone || !moment.tz.zone(this.editBroadcast.timezone)) {
            useUIStore().updateToast({ open: true, message: "Please select a timezone", type: "danger" });
            return false;
          }

        // Extract and format the date and time for display and validation
        const fullDateTime = new Date(this.editBroadcast.send_date_time);
        const justDate = `${fullDateTime.getFullYear()}-${this.make2DigitDateParts(fullDateTime.getMonth() + 1)}-${this.make2DigitDateParts(fullDateTime.getDate())}`;
        const justTime = `${this.make2DigitDateParts(fullDateTime.getHours())}:${this.make2DigitDateParts(fullDateTime.getMinutes())}`;
          
        // Get current time in the user's timezone
        const nowMoment = moment().tz(this.editBroadcast.timezone);
        // Get the selected time
        const selectedMoment = moment.tz(`${justDate} ${justTime}`, this.editBroadcast.timezone);

        // Calculate the duration in minutes
        const duration = selectedMoment.diff(nowMoment, 'minutes');

        if (duration < 5) {
          useUIStore().updateToast({ open: true, message: "The selected schedule time should be at least 5 minutes later from now!", type: "danger" });
          return false;
        }
        // Format and store the validated date-time in the desired format
        this.editBroadcast.send_date_time = `${this.make2DigitDateParts(fullDateTime.getDate())}/${this.getFullMonthNameByIndex(fullDateTime.getMonth(), true)}/${fullDateTime.getFullYear()} ${this.make2DigitDateParts(fullDateTime.getHours())}:${this.make2DigitDateParts(fullDateTime.getMinutes())}:00`;
      }
      
      // ************** end primary validations **************


      // ------------ email channel validations -----------
      if (selectedBroadCastChannel == 'email') {
        const emailValidationA = this.$refs.emailCreateMessage_A?.validate?.() || { valid: false, message: 'Please create your email message.' };
        if (!emailValidationA.valid) {
          const message = this.abTestingOn ? `${emailValidationA.message} (Version A)` : emailValidationA.message;
          useUIStore().updateToast({ open: true, message, type: "danger" });
          return false;
        }
        if (this.abTestingOn) {
          const emailValidationB = this.$refs.emailCreateMessage_B?.validate?.() || { valid: false, message: 'Please create your email message.' };
          if (!emailValidationB.valid) {
            useUIStore().updateToast({ open: true, message: `${emailValidationB.message} (Version B)`, type: "danger" });
            return false;
          }
        }
        return; // email handled; skip the JsonBuilder-based non-WA validation
      }
      // ************** end email channel validations **************

      // ------------ non whatsapp channels validations -----------
      if( selectedBroadCastChannel != 'whatsapp' ) {
        let errorInVersionA = this.validateNonWaChannels(VERSION_A);
        if(errorInVersionA) {
          if(this.abTestingOn) {
            errorInVersionA += ' (Version A)'
          }
          useUIStore().updateToast({ open: true, message: errorInVersionA, type: "danger" });
          return false;
        }

        if(this.abTestingOn) {
          let errorInVersionB = this.validateNonWaChannels(VERSION_B);
          if(errorInVersionB) {
            errorInVersionB += ' (Version B)'
            useUIStore().updateToast({ open: true, message: errorInVersionB, type: "danger" });
            return false;
          }
        }
      }
      // ************** end non whatsapp channels validations **************

    },
    async saveBroadcastHandler() {

      const isBoradcastValid = this.validateBroadcastBeforeSave();
      if(isBoradcastValid == false) {
        return;
      }

      if (this.selectedBroadCastChannel == 'whatsapp') {

        //check whatsapp validation
        const isWaValid_version_A = this.$refs.whatsAppCreateMessage_A.isValidToSubmit();
        if (!isWaValid_version_A) {
          return;
        }

        if(this.abTestingOn) {
          const isWaValid_version_B = this.$refs.whatsAppCreateMessage_B.isValidToSubmit();
          if (!isWaValid_version_B) {
            return;
          }
        }

        const loadingMessage = this.sendNow == 'now' ? "Saving and Sending Broadcast" : "Saving Broadcast";
        useUIStore().updateLoading({ isLoading: true, message: loadingMessage });
        let options = { sendNow: this.sendNow, sendMode: this.sendMode, pageId: this.selectSocialPageId };

        // set targeting conditions
        if (this.targetingOption == 'SELECT_SEGMENT') {
          options.segmentId = `${this.selectedSegment.id}`;
        } else if (this.targetingOption == UPLOAD_FILE) {
          options.destination_blob_name = this.uploadedFileObject.filePath;
          if(this.isNewFileUploaded) {
            options.targeting_count = this.fileUploadCount;
          }
        } else {
          const queryString = this.$refs.CustomerSegments.getQueryStringFromConditionArray()?.trim();
          options.targetingConditions = queryString;
        }
        // FallBack Message 
        if(this.enableFallBackMessage) {
          this.finalFallBackMessageArray[0].message = [];
          this.finalFallBackMessageArray[0].message.push(this.fallbackMessagePayload);
          options.failover_messages = this.finalFallBackMessageArray;
        }

        const { waTemplateId: waTemplateId_A, message_params: message_params_A, custom_messages: custom_messages_A  } = this.$refs.whatsAppCreateMessage_A.getBroadcastMessageParamsToSave();
        options = { ...options, ...{waTemplateId_A, message_params_A, custom_messages_A, uploaded_type: this.finalUrlType, selectSMSSenderID: this.selectSMSSenderID, isNewFileUploaded: this.isNewFileUploaded} };

        if(this.abTestingOn) {
          const { waTemplateId: waTemplateId_B, message_params: message_params_B, custom_messages: custom_messages_B  } = this.$refs.whatsAppCreateMessage_B.getBroadcastMessageParamsToSave()
          options = { ...options, ...{waTemplateId_B, message_params_B, custom_messages_B, distribution_probability: this.editBroadcast.distribution_probability, uploaded_type_B: this.finalUrlType_B, selectSMSSenderID: this.selectSMSSenderID, isNewFileUploaded: this.isNewFileUploaded} };
        }
        const saveBroadcastResponse = await this.$refs.whatsAppCreateMessage_A.saveBroadcast(options);
        if (saveBroadcastResponse) {
          if(this.editBroadcast.id) {
            let thisBroadcast = this.allbroadcasts.find((e) => e.id === this.editBroadcast.id);
            for (var prop in thisBroadcast) {
              thisBroadcast[prop] = saveBroadcastResponse[prop];
            }
          } else {
            if(this.activeListingTab == 'broadcasts'){
              this.allbroadcasts.unshift(saveBroadcastResponse);
            } else {
              this.allDraftBroadcasts.unshift(saveBroadcastResponse);
            }
          }
          this.editMode = false;
          this.showMessages = false;
          this.isDuplicateBroadcast = false;
          const message = this.sendNow == 'now' ? "The Broadcast has been saved and sent" : "The Broadcast has been saved";
          useUIStore().updateToast({ open: true, message: message, type: "success", });
          this.broadcastIndexToEdit = -1;
          this.resetListSearch();
          this.fetchBroadcasts();
          this.fetchDraftBroadcasts();
        }
        useUIStore().updateLoading({ isLoading: false });

      } else if (this.targetingOption == UPLOAD_FILE) {
        this.csvBroadCastUpload();
      } else {
        this.saveBroadcast();
      }
    },
    async saveBroadcast() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Saving broadcast...' });
        let reqBody;
        reqBody = this.getFormattedMessageRequestBody();
        if (reqBody === undefined) {
          return;
        } else {
        // Email bodies allow up to 100KB (enforced in EmailCreateMessage.validate); the 16KB
        // guard only applies to the other channels' interactive message payloads.
        if(this.editBroadcast.channel !== 'email' && jsonSizeInKB(reqBody?.messages) > 16){
          return useUIStore().updateToast({ open: true, message: 'The information you are sending (called a "payload") exceeds the API limit of 16 KB.Please reduce the size of your message, attachments, or interactive elements, and try again.', type: "danger", duration: 7000 });
        }
        let savedBroadcast;
        const isDraft = this.sendNow === 'draft';
        const hasId = !!reqBody?.id;
        const type = isDraft ? 'drafts' : 'broadcasts';
        const method = hasId ? 'patch' : 'post';
        const url = hasId
          ? `${environment("VUE_APP_API_URL")}broadcasts/v1/${type}/${reqBody.id}`
          : `${environment("VUE_APP_API_URL")}broadcasts/v1/${type}`;

        savedBroadcast = await apiInterceptor[method](url, reqBody);
        const message = this.sendNow === 'now' ? "The Broadcast has been saved and sent" : this.sendNow === 'later' ? "The Broadcast has been saved" : "The Broadcast has been saved as draft successfully";
        useUIStore().updateToast({ open: true, message, type: "success", });
        this.editMode = false;
        this.showMessages = false;
        this.broadcastIndexToEdit = -1;
        this.clearBroadcast();
        this.fetchBroadcasts();
        this.fetchDraftBroadcasts();
        if(this.activeListingTab == 'broadcasts'){
          this.allbroadcasts.unshift(savedBroadcast);
        } else {
          this.allDraftBroadcasts.unshift(savedBroadcast);
          this.activeListingTab = 'draft_broadcast';
        }
      }
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async csvBroadCastUpload() {
      try {
        const isEmailChannel = this.editBroadcast.channel === 'email';
        const messages = isEmailChannel ? this.getEmailMessagesJson(VERSION_A) : this.getAdMessageJson(VERSION_A, false);
        if (messages === undefined) {
          return;
        } else {
        if(!isEmailChannel && jsonSizeInKB(messages) > 16){
          return useUIStore().updateToast({ open: true, message: 'The information you are sending (called a "payload") exceeds the API limit of 16 KB.Please reduce the size of your message, attachments, or interactive elements, and try again.', type: "danger", duration: 7000 });
        }
        useUIStore().updateLoading({ isLoading: true, message: 'Uploading broadcast...' });
        if(this.uploadedFileObject.filePath == '') {
          return useUIStore().updateToast({ open: true, message: "Please upload file and try again", type: "danger", });
        }
        if(!isEmailChannel && messages?.length > 0){
          const elementType = this.adMessageJsonElements_A[0]?.type;
          messages[0].message_type = elementType === 'richcard' ? 'richcard' : (messages[0]?.template_type?.includes('carousel') ? 'carousel' : messages[0]?.template_type);
        }
        let reqBody = {
          messages: messages,
          shopname: useAuthStore().cleanUserData?.referallshopName,
          mode: this.sendNow == 'now' ? "send" : this.sendNow == 'later' ?  "save" : "draft",
          pageid: JSON.stringify(this.selectSocialPageId),
          channel: this.editBroadcast.channel,
          name: this.editBroadcast.name,
          destination_blob_name: this.uploadedFileObject.filePath,
        };
        if (isEmailChannel) {
          // Email-specific top-level fields (subject + sender; null for "Custom").
          reqBody.email_subject = messages[0]?.email_subject || '';
          const emailSenderId = this.getFormattedEmailSenderId();
          if (emailSenderId !== undefined) {
            reqBody.email_sender_id = emailSenderId;
          }
        } else {
          reqBody.url_types = {"HEADER": [this.finalUrlType]};
        }
        if(this.sendTag !== undefined) {
          reqBody.sendtag = this.sendTag;
        }
        if(this.isNewFileUploaded){
          reqBody.targeting_count = this.fileUploadCount;
        }
        if (!isEmailChannel) {
          reqBody.sender_id = this.selectSMSSenderID === 'custom' ? null : this.selectSMSSenderID; // sms senderID
        }
        // set params for send later
        if (this.sendNow == 'later') {
          reqBody.timezone = this.editBroadcast.timezone;
          reqBody.send_date_time = moment(this.editBroadcast.send_date_time).format('DD/MM/YYYY HH:mm:ss');
        }

        // // in case edit mode pass broadcast id
        if (this.editBroadcast?.id && !this.isDuplicateBroadcast) {
          reqBody.id = this.editBroadcast?.id
        }

        // A-B testing parameters
        if (!isEmailChannel && this.abTestingOn) {
            const adMessageJsonB = this.getAdMessageJson(VERSION_B, false);
            if (adMessageJsonB === undefined) {
              return;
            } else {
              if(adMessageJsonB?.length > 0){
                const elementType_B = this.adMessageJsonElements_B[0]?.type;
                adMessageJsonB[0].message_type = elementType_B === 'richcard' ? 'richcard' : (adMessageJsonB[0]?.template_type?.includes('carousel') ? 'carousel' : adMessageJsonB[0]?.template_type);
              }
              reqBody.messagelisted = JSON.stringify(adMessageJsonB || []);
              reqBody.distribution_probability = this.editBroadcast.distribution_probability;
              reqBody.url_types_b = {"HEADER": [this.finalUrlType_B]}; // Only add when A-B testing is on
            }
          }
        // A-B testing parameters for email (Version B messages + distribution split; no url_types_b).
        if (isEmailChannel && this.abTestingOn) {
          const emailMessagesB = this.getEmailMessagesJson(VERSION_B);
          if (emailMessagesB === undefined) {
            return;
          }
          reqBody.messagelisted = JSON.stringify(emailMessagesB || []);
          reqBody.distribution_probability = this.editBroadcast.distribution_probability;
        }
         //FallBack Message
        if(!isEmailChannel && this.enableFallBackMessage) {
          this.finalFallBackMessageArray[0].message = [];
          this.finalFallBackMessageArray[0].message.push(this.fallbackMessagePayload);
          reqBody.failover_messages = this.finalFallBackMessageArray;
        }
        let savedBroadcast;
        if (this.sendNow === 'draft') {
          if(reqBody?.id) {
            // Update Draft Broadcast
            savedBroadcast = await apiInterceptor.patch( environment("VUE_APP_API_URL") + `broadcasts/v1/drafts/${reqBody?.id}`, reqBody );
          } else {
            // Save Draft Broadcast
            savedBroadcast = await apiInterceptor.post( environment("VUE_APP_API_URL") + "broadcasts/v1/drafts", reqBody );
          }
        } else {
          savedBroadcast = await apiInterceptor.post(environment('VUE_APP_API_URL') + "broadcast-executor/send", reqBody, );
        }
        this.editMode = false;
        this.showMessages = false;
        this.broadcastIndexToEdit = -1;
        const message = this.sendNow === 'now' ? "The Broadcast has been saved and sent" : this.sendNow === 'later' ? "The Broadcast has been saved" : "The Broadcast has been saved as draft successfully";
        useUIStore().updateToast({ open: true, message: message, type: "success", });
        this.broadcastIndexToEdit = -1;
        this.clearBroadcast();
        this.fetchBroadcasts();
        this.fetchDraftBroadcasts();
        if(this.activeListingTab == 'broadcasts'){
          this.allbroadcasts.unshift(savedBroadcast);
        } else {
          this.allDraftBroadcasts.unshift(savedBroadcast);
          this.activeListingTab = 'draft_broadcast';
        }
      }
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async fetchSegments() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Loading segments...' });
        this.allSegments = await queryClient.fetchQuery(segmentsQueryOptions());
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message, type: "danger", });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async downloadCsv_broadcastOutcome(id) {
      try {
        this.csvExportWithDateRangeModal_open('broadcast','Download broadcast outcome', id);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message, type: "danger" });
      }
    },
    accordionGroupChange(value){
      this.selectedAccordion = this.selectedAccordion === value ? '' : value;
    },
    getThisSegmentChannel(segmentData) {
      if (typeof segmentData !== 'undefined') {
          let channel = this.editBroadcast.channel;
          let target_conds = segmentData.targeting_conditions;

          if (typeof target_conds === 'string') {
            const match = segmentData.targeting_conditions.match(/platform\s*=\s*\"([^\"]+)\"/);
            return match ? match[1] : null;
          }

          const processQuery = (query) => { // Helper function to extract the platform from a query string
              const match = query.match(/platform\s*=\s*"([^"]+)"/);
              return match ? match[1] : null;
          };

          if (Array.isArray(target_conds)) {
            for (const condition of target_conds) {
              const platform = processQuery(decodeURIComponent(condition.query));
              if (platform) {
                  channel = platform;
                  break;
              }
            }
          } else {
              const platform = processQuery(decodeURIComponent(target_conds));
              if (platform) {
                  channel = platform;
              }
          }

          return channel;
      }
    },
    async getSmsTranscodedMessage(text){
      try {
        const trimmedText = text ? text.trim() : '';
        if(trimmedText == '' || trimmedText == undefined){
          return useUIStore().updateToast({ open: true, message: 'Please enter text message before transcoding!', type: "danger" })
        } else {
          useUIStore().updateLoading({ isLoading: true, message: 'Transcoding message...' });
          let reqBody = {
            text: text
          };
          let smsEncoderResponse = await apiInterceptor.post(environment('VUE_APP_API_URL') + "broadcasts/v1/utilities/sms-encode", reqBody);
          this.fallbackMessagePayload = smsEncoderResponse?.encoded_text;
          useUIStore().updateToast({
            open: true,
            message: 'Trascoded Message Applied Succesfully',
            type: "success"
          });
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    getTemplateData(value, version) {
      this.allTemplateData = value;
      if (this.abTestingOn) {
        if (version === 'A') {
          this.allTemplateData_A = this.allTemplateData;
          this.template_subtype_A = this.allTemplateData.template_subtype_A || this.allTemplateData.template_subtype;
        } else if (version === 'B') {
          this.allTemplateData_B = this.allTemplateData;
          this.template_subtype_B = this.allTemplateData.template_subtype_B || this.allTemplateData.template_subtype;
        }
      } else {
        this.allTemplateData_A = this.allTemplateData;
        this.template_subtype_A = this.allTemplateData.template_subtype;
      }
      // Default assignment
      this.template_subtype = this.template_subtype_A;
    },
    setMessageTags(){
      this.simpleMessageTags = messageTags?.allChannelsMessageTags?.filter(({tag}) => ['userfirstname', 'userlastname', 'useremail', 'userphone'].includes(tag));
    },
    stopPolling() {
      clearInterval(this.intervalId); // Clear the interval
    },
    async getBroadcastDetailsviaID(id) {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Loading broadcast details...' });
        const getBroadcastDetailsResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "broadcasts/v1/broadcasts/" + id );
        return getBroadcastDetailsResponse;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" });
        return null;
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    shouldPollFutureBroadcast(timezone, dateTimeString) {
        // Parse the target time
        const targetTime = timezone
            ? moment.tz(dateTimeString, "MM/DD/YYYY, HH:mm:ss", timezone)
            : moment(dateTimeString, "MM/DD/YYYY, HH:mm:ss");

        // Get the current time
        const currentTime = timezone
            ? moment.tz(timezone)
            : moment();

        // Calculate the difference in hours
        const differenceInHours = targetTime.diff(currentTime, 'hours');

        // Return true if the target time is within 1 hour from now
        return differenceInHours <= 1 && differenceInHours >= 0;
    },
    handleFileUpload(data) {
      this.uploadedFileObject = {
        fileName: data.fileName,
        filePath: data.filePath,
      };
      this.fileUploadCount = data.targetingCount;
      this.isNewFileUploaded = true;
    },
    resetUploadedFileObject() {
      this.uploadedFileObject.fileName = '';
      this.uploadedFileObject.filePath = '';
      this.fileUploadCount = 0;
      this.isNewFileUploaded = false;
      // Reset the targeting count for file uploads
      this.editBroadcast.targeting_count = null;
      // Reset targeting count when targeting option changes
      if (this.$refs.SegmentsTargetingCount) {
        this.$refs.SegmentsTargetingCount.targetedCustomerCount = '-';
      }
      
      // Clear existing segment conditions when switching to SELECT_FILTERS
      if (this.targetingOption === 'SELECT_FILTERS') {
        // Clear existing conditions and targeting_conditions from editBroadcast
        this.editBroadcast.targeting_conditions = '';
        // Force reload CustomerSegments component to reset with default conditions
        this.reloadCustomerSegments = false;
        this.$nextTick(() => {
          this.reloadCustomerSegments = true;
        });
      }
    },
    deleteUploadedFilePath() {
      this.resetUploadedFileObject();
      this.$refs.UploadCSVComponent?.resetUploadComponent();
    },
    // Clears both listing search fields so the list is shown unfiltered on
    // return from any operation. Setting to undefined trips the empty-value
    // watchers which re-fetch the full lists.
    resetListSearch() {
      this.broadcastFilter = undefined;
      this.draftBroadcastFilter = undefined;
    },
    clearBroadcast() {
      // Clear the listing search so returning from an operation (e.g. duplicate)
      // shows the full, unfiltered list.
      this.resetListSearch();
      this.resetSettings();
      this.isDuplicateBroadcast = false;
      this.iseditDraftbroadcast = false;
      this.objWhatsAppPreview_A = {};
      this.objWhatsAppPreview_B = {};
      this.allTemplateData = {};
      this.allTemplateData_B = {};
      this.allTemplateData_A = {};
      this.editBroadcast = { 
        ...editBroadcast, 
        timezone: useAuthStore().cleanUserData?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone 
      };
      this.$refs.whatsAppCreateMessage_A?.resetTemplateValues();
    },
    make2DigitDateParts(value) {
      return value < 10 ? `0${value}` : `${value}`;
    },
    getFullMonthNameByIndex(monthIndex, short = false) {
      const months = short
        ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return months[monthIndex];
    },
    getActualFilename(url) {
      const fullFilename = url.substring(url.lastIndexOf("/") + 1);
      return fullFilename.replace(/^[a-f0-9-]+-/, "");
    },
    formatPayloadDateRange(payload) {
      if (!payload) return '';

      const [start, end] = payload.split(' ');

      if (!start || !end) return '';

      const startFormatted = moment(start).format('MM/DD/YYYY, HH:mm:ss');
      const endFormatted = moment(end).format('MM/DD/YYYY, HH:mm:ss');

      return `${startFormatted}, ${endFormatted}`;
    },
    formatDateTimeToISOString(payload) {
			const format = "MM/DD/YYYY, HH:mm:ss";
		
			let parts = payload.split(",");

			if (parts.length < 4) {
        payload = this.formatPayloadDateRange(payload);
        parts = payload.split(",");
			}
			const startStr = `${parts[0].trim()},${parts[1].trim()}`;
			const endStr = `${parts[2].trim()},${parts[3].trim()}`;
		
			const start = moment(startStr, format);
			const end = moment(endStr, format);
      const now = moment();
		
			if (!start.isValid() || !end.isValid()) {
				useUIStore().updateToast({
					open: true,
					message: "Invalid date format. Please check the inputs.",
					type: "danger",
				});
        return { error: "Invalid date format. Please check the inputs." };
			}
      if (start.isBefore(now)) {
        useUIStore().updateToast({
          open: true,
          message: "Start date and time cannot be in the past.",
          type: "danger",
        });
        return { error: "Start date and time cannot be in the past." };
      }

			if (end.isBefore(start)) {
				useUIStore().updateToast({
					open: true,
					message: "End date cannot be earlier than start date.",
					type: "danger",
				});
        return { error: "Start date and time cannot be in the past." };
			}
		
			return `${start.toISOString(true)} ${end.toISOString(true)}`;
		},
    parseBodyText(text){
			if(text !== undefined){
				return text.replace(/<br\s*\/?>/gi, '\n');
			}
		},
    validateCalendarButton(button) {
      if (button?.type === 'calendar' && button?.payload) {
        const alternativePayloadFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

        // Normalize the payload if in alternative ISO format
        if (alternativePayloadFormat.test(button.payload)) {
          button.payload = this.formatPayloadDateRange(button.payload);
        }
        // Parse formatted payload
        const payloadParts = button.payload.split(',');
        const format = "MM/DD/YYYY, HH:mm:ss";
        const startDateAndTimeStr = payloadParts[0]?.trim() + ', ' + payloadParts[1]?.trim();
        const endDateAndTimeStr = payloadParts[2]?.trim() + ', ' + payloadParts[3]?.trim();

        const start = moment(startDateAndTimeStr, format, true);
        const end = moment(endDateAndTimeStr, format, true);
        const now = moment();

        // Check if start or end is before current time
        if (start.isBefore(now)) {
          return `Please enter a valid start date & time for button "${button.title}".`;
        }

        if (end.isBefore(now)) {
          return `Please enter a valid end date & time for button "${button.title}".`;
        }

        // Check if end is before start
        if (end.isBefore(start)) {
          return `End date & time cannot be earlier than start date & time for button "${button.title}".`;
        }
      }
    },
    fetchAllTemplatesData(){
      this.$nextTick(() => {
        if(this.selectedBroadCastChannel == 'whatsapp' && (!this.isViewMode || this.isDuplicateBroadcast)) {
          this.fetchTemplates();
        }
      });
    },
    fetchTemplatesForViewMode() {
      if(this.isViewMode && this.selectedBroadCastChannel == 'whatsapp') {
        this.fetchTemplates();
      }
    },
    async fetchTemplates() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Loading templates...' });
        if (!this.getWhatsApp?.id) {
          this.allTemplates = [];
          return;
        }

        const queryOptions = whatsappTemplatesQueryOptions(this.getWhatsApp.id, { size: '-1' });

        // Always mark templates stale so create-broadcast opens with fresh server data.
        await queryClient.invalidateQueries({ queryKey: queryOptions.queryKey });

        // Force a fresh call and update query cache with latest template list.
        const response = await queryClient.fetchQuery({
          ...queryOptions,
          staleTime: 0,
        });

        const templates = (response.templates || []).filter(
          (objTemplate) => objTemplate && objTemplate?.status === 'APPROVED'
        );
        this.allTemplates = templates;
        this.allTemplates.sort((a, b) => a.template_name.localeCompare(b.template_name));
      } catch (error) {
        useUIStore().updateToast({ open: true, message: "Something went wrong", type: "danger" })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async changeTab(newTab) {
      this.activeListingTab = newTab;
      // Clear both search fields so a search on one tab doesn't linger when
      // switching to the other.
      this.resetListSearch();
      if(this.activeListingTab == 'draft_broadcast'){
        this.sendNow = 'draft'
        if(!this.draftBroadcastsFetched){
          await this.fetchDraftBroadcasts();
          this.draftBroadcastsFetched = true;
        }
      } else {
        this.sendNow = 'now'
      }
    },
    getUploadecCSVFilename(filePath) {
      if (!filePath) return '';
      // Get the part after the last slash
      const fullFilename = filePath.substring(filePath.lastIndexOf('/') + 1);
      // Remove UUID prefix (ending with the first '-' after the UUID)
      return fullFilename.replace(/^[a-f0-9-]{36,}-/, '');
    },
    updateBroadcastStatus(e) {
      const data = e.detail;
      if(data?.id) {
        const thisBroadcast = this.allbroadcasts.find(e => e.id === data.id);
        if (thisBroadcast) {
          thisBroadcast.sent_status = data?.sent_status;
        } else {
          console.warn(`Broadcast with id ${data.id} not found in allbroadcasts`);
        }
      }
    }
  },
};
</script>

<style scoped>

.hideVersion {
  display: none;
}

@media (min-width:801px)  {
  /*---------- segment action desktop css ----------*/
  .segments-wrapper {
    position: relative;
  }
  .action-transparent-background {
    position: fixed;
    z-index: 998;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  /*********** end segment action desktop css ************/
}
.flexBox {
  display: flex;
  column-gap: 10px;
}
.broadcast-search-container{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin: 20px;
}
ion-button.analyticsBttn{
  --background: var(--white);
  --box-shadow: none;
  color: var(--gray-04);
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.broadcast-search-field {
  width: 30%;
}
.not-channel-connected-text-wrapper {
  height: calc(100% - 60px);
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.date-time-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.date-time-wrapper .left {
  display: flex;
  flex: 1;
  column-gap: 10px;
}
.select-segment-wrapper {
  margin: 20px 0px;
  border: 1px solid var(--background-primary);
  border-radius: 5px;
}
.select-segment-wrapper .sub-text{
  padding-left: 15px;
}
.link-text {
  color: var(--purple);
  text-decoration: underline;
}
.model-sections {
  background: var(--white);
  border-radius: 5px;
}
.custPaddingRight{
  padding-right: 20px;
}
.tooltip_container .tooltip_text.left {
  top: 5%;
}
.hideSendLaterSection {
  display: none;
}
.selectedCSV{
  background: var(--background-primary);
  padding: 15px 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}
.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  background: var(--purple-opac);
  padding: 15px 10px;
  border-radius: 5px;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
  margin-left: 8px;
}

.filterImg{
  max-width: 200px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.hoverUnderline{
  text-decoration: none;
}

.prevMobile {
  display: none;
}
.prevDesktop {
  display: block;
}
.custom-tabs {
  display: flex;
  border-bottom: 2px solid var(--background-primary);
  background: var(--white);
  min-height: 50px;
  align-items: center;
}
.custom-tab {
  background: none;
  border: none;
  padding: 12px 20px;
  font-size: 14px;
  cursor: pointer;
  color: var(--black);
  position: relative;
  flex: 1;
  text-align: center;
}
.custom-tab.active {
  color: var(--purple);
}
.custom-tab.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--purple);
}
.listContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  gap: 10px;
}
.refreshIcon{
  color: #ffffff;
}
.dateContainer{
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px 0;
  background: var(--white);
}
.h2margin{
  margin: 10px 0px;
}
.marginTop{
  margin-top: 20px;
}
.custPadding{
  padding-bottom: 15px;
}
.btn-primary {
  background: var(--purple);
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-secondary {
  background: var(--white);
  color: var(--gray-04);
  border: 1px solid var(--background-primary);
  border-radius: 5px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}
.btn-outline {
  background: var(--white);
  color: var(--purple);
  border: 1px solid var(--purple);
  border-radius: 5px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
}
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}
.radio_container {
  background: var(--background-primary);
  border-radius: 5px;
  padding: 10px;
  flex: 1;
}
.edit-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: var(--white);
  border-bottom: 1px solid var(--background-primary);
}
.toolbar-start {
  display: flex;
  align-items: center;
  gap: 10px;
}
.broadcast-grid {
  padding: 0;
}
.broadcast-row {
  display: flex;
  flex-direction: row;
  gap: 0;
}
.broadcast-col-main {
  flex: 0 0 66.67%;
  max-width: 66.67%;
  padding-right: 20px;
}
.broadcast-col-preview {
  flex: 0 0 33.33%;
  max-width: 33.33%;
}
.broadcast-listing-content {
  height: 100%;
  overflow-y: auto;
}
.broadcast-edit-content {
  height: 100%;
  overflow-y: auto;
}
.accordion-header {
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: pointer;
}
.accordion-chevron {
  margin-left: auto;
  color: var(--gray-04);
  transition: transform 0.2s ease;
}
.accordion-chevron.open {
  transform: rotate(180deg);
}
.accordion-content {
  border-top: 1px solid var(--background-primary);
}
.accordion-slide-enter-active,
.accordion-slide-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  overflow: hidden;
}
.accordion-slide-enter-to,
.accordion-slide-leave-from {
  max-height: 1500px;
  opacity: 1;
}
.accordion-slide-enter-from,
.accordion-slide-leave-to {
  opacity: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.search-input {
  background: var(--white);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.radioContainer {
  display: flex;
  align-items: center;
  gap: 15px;
}
.radio-bttn-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.radio-card {
  flex: 1 1 calc(25% - 8px);
  max-width: calc(25% - 8px);
  background: var(--background-primary);
  border-radius: 5px;
  padding: 12px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s;
}
.create-broadcast-channel-selection-radio-group.radio-bttn-container {
  flex-wrap: nowrap;
}
.create-broadcast-channel-selection-radio-group .radio-card {
  flex: 1 1 0;
  max-width: none;
}
.radio-card.selected {
  border-color: var(--purple);
}
.radio-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.radio-card:hover:not(.disabled) {
  border-color: var(--purple);
}
.radio-hidden {
  display: none;
}
.schedule-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}
.schedule-radio-card {
  padding: 15px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.schedule-radio-card:hover:not(.disabled) {
  background-color: var(--background-primary);
}
.schedule-radio-card.selected {
  background-color: var(--background-primary);
}
.schedule-radio-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.radio-input {
  accent-color: var(--purple);
  width: 18px;
  height: 18px;
  margin-top: 2px;
  flex-shrink: 0;
  cursor: pointer;
}
/* In view/disabled mode the card shows a not-allowed cursor; keep the radio
   input consistent instead of showing a pointer over it. */
.schedule-radio-card.disabled .radio-input {
  cursor: not-allowed;
  pointer-events: none;
}
.radio-label-content {
  display: flex;
  flex-direction: column;
}
.accordion-container{
  border-radius: 5px;
  background: var(--white);
  margin-bottom: 15px;
}
.number {
  background-color: var(--background-primary);
  border-radius: 50%;
  color: var(--black);
  display: inline-block;
  height: 24px;
  line-height: 24px;
  margin-right: 10px;
  text-align: center;
  width: 24px;
  font-size: 14px;
}
.header{
  font-size: 16px;
  font-weight: 400;
  color: var(--black);
}
.activeAccordion{
  color: #ffffff;
  background: var(--purple);
}
.paddingLeft{
  padding-left: 10px;
}
.chat-toolbar{
  padding-right: 10px;
}

.emptyBroadcast{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 130px auto;
}
.fallBackContainer{
  display: flex;
  gap: 20px;
}
.fallBackMessages{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.insertVariables {
  margin-left: 5px;
}
.fileImg{
  width: 40px;
  height: 40px;
}
.flex-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0px;
}
.modal-header{
  font-size: 16px;
  color: var(--black);
  font-weight: 400;
}
.paddingNone {
  padding-left: 0px;
}
@media only screen and (max-width: 768px) {
  .broadcast-search-field{
    width: 100%;
  }
  .broadcast-search-container{
    gap: 20px;
  }
  .prevMobile {
		display: block;
	}
  .prevDesktop {
  	display: none;
	}
  .custPaddingRight{
    padding-right: 0px;
  }
  .broadcast-col-main {
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 0;
  }
  .broadcast-col-preview {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .broadcast-row {
    flex-direction: column;
  }
}

/* Email Preview Styles */
</style>